;(window.slate = window.slate || {}),
  (window.theme = window.theme || {}),
  (slate.a11y = {
    getFirstFocusableChild: function(t) {
      return t.find('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])').first()
    },
    pageLinkFocus: function(t) {
      var e = 'js-focus-hidden'
      t.first()
        .attr('tabIndex', '-1')
        .focus()
        .addClass(e)
        .one('blur', function() {
          t.first()
            .removeClass(e)
            .removeAttr('tabindex')
        })
    },
    focusHash: function() {
      var t = window.location.hash
      t && document.getElementById(t.slice(1)) && this.pageLinkFocus($(t))
    },
    bindInPageLinks: function() {
      $('a[href*=#]').on(
        'click',
        function(t) {
          this.pageLinkFocus($(t.currentTarget.hash))
        }.bind(this)
      )
    },
    trapFocus: function(e) {
      var t = e.namespace ? 'focusin.' + e.namespace : 'focusin'
      e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr('tabindex', '-1'),
        e.$elementToFocus.focus(),
        $(document).on(t, function(t) {
          e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
        })
    },
    removeTrapFocus: function(t) {
      var e = t.namespace ? 'focusin.' + t.namespace : 'focusin'
      t.$container && t.$container.length && t.$container.removeAttr('tabindex'),
        $(t.$element).focus(),
        $(document).off(e)
    },
  }),
  (slate.utils = {
    findInstance: function(t, e, i) {
      for (var n = 0; n < t.length; n++) if (t[n][e] === i) return t[n]
    },
    removeInstance: function(t, e, i) {
      for (var n = t.length; n--; )
        if (t[n][e] === i) {
          t.splice(n, 1)
          break
        }
      return t
    },
    compact: function(t) {
      for (var e = -1, i = null == t ? 0 : t.length, n = 0, s = []; ++e < i; ) {
        var o = t[e]
        o && (s[n++] = o)
      }
      return s
    },
    defaultTo: function(t, e) {
      return null == t || t != t ? e : t
    },
    getQueryParams: function() {
      var t = (location.search && location.search.substr(1)) || '',
        e = {}
      return (
        t
          .split('&')
          .filter(function(t) {
            return t.length
          })
          .forEach(function(t) {
            t = t.split('=')
            1 < t.length ? (e[t[0]] = t[1]) : (e[t[0]] = !0)
          }),
        e
      )
    },
    getQueryString: function() {
      var t = (location.search && location.search.substr(1)) || ''
      return (t = t.length ? '?' + t : t)
    },
    getUrlWithUpdatedQueryStringParameter: function(t, e, i) {
      i = i || window.location.href
      var n = new RegExp('([?&])' + t + '=.*?(&|$)', 'i'),
        s = -1 !== i.indexOf('?') ? '&' : '?'
      return i.match(n) ? i.replace(n, '$1' + t + '=' + e + '$2') : i + s + t + '=' + e
    },
    getUrlWithRemovedQueryStringParameter: function(t, e) {
      var i = (e = e || window.location.href).split('?')[0],
        n = [],
        e = -1 !== e.indexOf('?') ? e.split('?')[1] : ''
      if ('' !== e) {
        for (var s = (n = e.split('&')).length - 1; 0 <= s; --s) n[s].split('=')[0] === t && n.splice(s, 1)
        0 < n.length && (i = i + '?' + n.join('&'))
      }
      return i
    },
    isThemeEditor: function() {
      return null !== location.href.match(/myshopify.com/) && null !== location.href.match(/theme_id/)
    },
    whichTransitionEnd: function() {
      var t,
        e = document.createElement('fakeelement'),
        i = {
          transition: 'transitionend',
          OTransition: 'oTransitionEnd',
          MozTransition: 'transitionend',
          WebkitTransition: 'webkitTransitionEnd',
        }
      for (t in i) if (void 0 !== e.style[t]) return i[t]
    },
    userAgentBodyClass: function() {
      var t,
        e = navigator.userAgent,
        i = document.documentElement,
        n = i.className
      ;/iPad|iPhone|iPod/.test(e) &&
        !window.MSStream &&
        ((n += ' ua-ios'),
        (t = e.match(/((\d+_?){2,3})\slike\sMac\sOS\sX/)) && (n += ' ua-ios-' + t[1]),
        /Twitter/.test(e) && (n += ' ua-ios-twitter'),
        /CriOS/.test(e) && (n += ' ua-ios-chrome')),
        /Android/.test(e) &&
          (n += (t = e.match(/Android\s([0-9\.]*)/)) ? ' ua-aos ua-aos-' + t[1].replace(/\./g, '_') : ' ua-aos'),
        /webOS|hpwOS/.test(e) && (n += ' ua-webos'),
        /SamsungBrowser/.test(e) && (n += ' ua-samsung'),
        (i.className = n)
    },
    hashFromString: function(t) {
      var e,
        i = 0
      if (0 === t.length) return i
      for (e = 0; e < t.length; e++) (i = (i << 5) - i + t.charCodeAt(e)), (i |= 0)
      return i
    },
    chosenSelects: function(t) {
      ;(t ? $('select.form-control', t) : $('select.form-control')).not('[data-no-chosen]').chosen()
    },
    cookiesEnabled: function() {
      var t = navigator.cookieEnabled
      return t || ((document.cookie = 'testcookie'), (t = -1 !== document.cookie.indexOf('testcookie'))), t
    },
    pluralize: function(t, e, i) {
      var n = ''
      return 1 == (t = parseInt(t)) ? (n = e) : void 0 === (n = i) && (n = e + 's'), n
    },
    clamp: function(t, e, i) {
      return Math.min(Math.max(t, e), i)
    },
    getViewportWidth: function() {
      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
    },
    getViewportHeight: function() {
      return Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    },
    childrenLargerThanParent: function(t, e) {
      if (!(t && t.length && e && e.length)) return !1
      var t = t[0].offsetWidth,
        i = 0
      return (
        e.each(function() {
          i += $(this)[0].offsetWidth
        }),
        t < i
      )
    },
    naturalMod: function(t, e) {
      return ((t % e) + e) % e
    },
    elementIsWithinViewport: function(t) {
      var e = t.offset().top,
        i = e + t.outerHeight(),
        n = $(window).scrollTop(),
        t = n + $(window).height()
      return n < i && e < t
    },
  }),
  (slate.constants = {
    cart: { ajax: { REFRESH: 'cart.ajax.REFRESH', UPDATE: 'cart.ajax.UPDATE', REMOVE: 'cart.ajax.REMOVE' } },
    productDetailForm: { READY: 'ready.productDetailForm' },
  }),
  (slate.rte = {
    wrapTables: function(t) {
      var e = void 0 === t.tableWrapperClass ? '' : t.tableWrapperClass
      t.$tables.addClass('table'), t.$tables.wrap('<div class="' + e + '"></div>')
    },
    wrapIframe: function(t) {
      void 0 === t.iframeWrapperClass || t.iframeWrapperClass
      t.$iframes.each(function() {
        $(this).wrap('<div class="' + t.iframeWrapperClass + '"></div>'), (this.src = this.src)
      })
    },
  }),
  (slate.Sections = function() {
    ;(this.constructors = {}),
      (this.instances = []),
      $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:section:reorder', this._onReorder.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this))
  }),
  (slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
    _createInstance: function(t, e) {
      var i = $(t),
        n = i.attr('data-section-id'),
        i = i.attr('data-section-type')
      void 0 !== (e = e || this.constructors[i]) &&
        ((t = $.extend(new e(t), { id: n, type: i, container: t })), this.instances.push(t))
    },
    _onSectionLoad: function(t) {
      t = $('[data-section-id]', t.target)[0]
      t && this._createInstance(t)
    },
    _onSectionUnload: function(t) {
      var e = slate.utils.findInstance(this.instances, 'id', t.detail.sectionId)
      e &&
        ('function' == typeof e.onUnload && e.onUnload(t),
        (this.instances = slate.utils.removeInstance(this.instances, 'id', t.detail.sectionId)))
    },
    _onSelect: function(t) {
      var e = slate.utils.findInstance(this.instances, 'id', t.detail.sectionId)
      e && 'function' == typeof e.onSelect && e.onSelect(t)
    },
    _onDeselect: function(t) {
      var e = slate.utils.findInstance(this.instances, 'id', t.detail.sectionId)
      e && 'function' == typeof e.onDeselect && e.onDeselect(t)
    },
    _onReorder: function(t) {
      var e = slate.utils.findInstance(this.instances, 'id', t.detail.sectionId)
      e && 'function' == typeof e.onReorder && e.onReorder(t)
    },
    _onBlockSelect: function(t) {
      var e = slate.utils.findInstance(this.instances, 'id', t.detail.sectionId)
      e && 'function' == typeof e.onBlockSelect && e.onBlockSelect(t)
    },
    _onBlockDeselect: function(t) {
      var e = slate.utils.findInstance(this.instances, 'id', t.detail.sectionId)
      e && 'function' == typeof e.onBlockDeselect && e.onBlockDeselect(t)
    },
    register: function(t, i) {
      ;(this.constructors[t] = i),
        $('[data-section-type=' + t + ']').each(
          function(t, e) {
            this._createInstance(e, i)
          }.bind(this)
        )
    },
  })),
  (slate.Currency = {
    formatMoney: function(t, e) {
      'string' == typeof t && (t = t.replace('.', ''))
      var i = '',
        n = /\{\{\s*(\w+)\s*\}\}/
      function s(t, e, i, n) {
        if (
          ((e = slate.utils.defaultTo(e, 2)),
          (i = slate.utils.defaultTo(i, ',')),
          (n = slate.utils.defaultTo(n, '.')),
          isNaN(t) || null == t)
        )
          return 0
        t = (t = (t / 100).toFixed(e)).split('.')
        return t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + i) + (t[1] ? n + t[1] : '')
      }
      switch ((e = e || '${{amount}}').match(n)[1]) {
        case 'amount':
          i = s(t, 2)
          break
        case 'amount_no_decimals':
          i = s(t, 0)
          break
        case 'amount_with_space_separator':
          i = s(t, 2, ' ', '.')
          break
        case 'amount_no_decimals_with_comma_separator':
          i = s(t, 0, ',', '.')
          break
        case 'amount_no_decimals_with_space_separator':
          i = s(t, 0, ' ')
      }
      return e.replace(n, i)
    },
  }),
  (slate.Image = {
    preload: function(t, e) {
      'string' == typeof t && (t = [t])
      for (var i = 0; i < t.length; i++) {
        var n = t[i]
        this.loadImage(this.getSizedImageUrl(n, e))
      }
    },
    loadImage: function(t) {
      new Image().src = t
    },
    imageSize: function(t) {
      return (t = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/))
        ? t[1]
        : null
    },
    getSizedImageUrl: function(t, e) {
      if (null === e) return t
      if ('master' === e) return this.removeProtocol(t)
      var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)
      if (i) {
        ;(t = t.split(i[0])), (i = i[0])
        return this.removeProtocol(t[0] + '_' + e + i)
      }
      return null
    },
    removeProtocol: function(t) {
      return t.replace(/http(s)?:/, '')
    },
  }),
  (slate.Variants = (function() {
    function t(t) {
      ;(this.$container = t.$container),
        (this.product = t.product),
        (this.singleOptionSelector = t.singleOptionSelector),
        (this.originalSelectorId = t.originalSelectorId),
        (this.enableHistoryState = t.enableHistoryState),
        (this.currentVariant = this._getVariantFromOptions()),
        $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this))
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        _getCurrentOptions: function() {
          var t = $.map($(this.singleOptionSelector, this.$container), function(t) {
            var e = $(t),
              i = e.attr('type'),
              t = {}
            return (
              (('radio' !== i && 'checkbox' !== i) || !!e[0].checked) &&
              ((t.value = e.val()), (t.index = e.data('index')), t)
            )
          })
          return (t = slate.utils.compact(t))
        },
        _getVariantFromOptions: function() {
          var t = this._getCurrentOptions(),
            e = this.product.variants,
            n = !1
          return (
            e.forEach(function(e) {
              var i = !0
              t.forEach(function(t) {
                i = i && t.value === e[t.index]
              }),
                i && (n = e)
            }),
            n || null
          )
        },
        _onSelectChange: function() {
          var t = this._getVariantFromOptions()
          $(['data-product-price']).trigger('click')
          var e = this
          setTimeout(function() {
            e.$container.trigger({ type: 'variantChange', variant: t })
          }, 100),
            t &&
              (this._updateMasterSelect(t),
              this._updateImages(t),
              this._updatePrice(t),
              (this.currentVariant = t),
              this.enableHistoryState && this._updateHistoryState(t))
        },
        _updateImages: function(t) {
          var e = t.featured_image || {},
            i = this.currentVariant.featured_image || {}
          t.featured_image && e.src !== i.src && this.$container.trigger({ type: 'variantImageChange', variant: t })
        },
        _updatePrice: function(t) {
          ;(t.price === this.currentVariant.price && t.compare_at_price === this.currentVariant.compare_at_price) ||
            this.$container.trigger({ type: 'variantPriceChange', variant: t })
        },
        _updateHistoryState: function(t) {
          history.replaceState &&
            t &&
            ((t =
              window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + t.id),
            window.history.replaceState({ path: t }, '', t))
        },
        _updateMasterSelect: function(t) {
          $(this.originalSelectorId, this.$container)[0].value = t.id
        },
      })),
      t
    )
  })()),
  (function(S, T, I) {
    'undefined' == typeof ShopifyAPI && (ShopifyAPI = {}),
      (ShopifyAPI.addItemFromForm = function(t) {
        var e = S.Deferred()
        return (
          S.ajax({
            type: 'post',
            dataType: 'json',
            url: '/cart/add.js',
            data: t.serialize(),
            success: function() {
              ShopifyAPI.getCart().then(function(t) {
                e.resolve(t)
              })
            },
            error: function() {
              e.reject({ message: 'The quantity you entered is not available.' })
            },
          }),
          e
        )
      }),
      (ShopifyAPI.getCart = function() {
        var e = S.Deferred(),
          t = I.utils.isThemeEditor() ? '/cart.js' : '/cart?view=json'
        return (
          S.ajax({
            type: 'get',
            url: t,
            success: function(t) {
              t = JSON.parse(t)
              e.resolve(t)
            },
            error: function() {
              e.reject({ message: 'Could not retrieve cart items' })
            },
          }),
          e
        )
      }),
      (ShopifyAPI.getProduct = function(t) {
        return S.getJSON('/products/' + t + '.js')
      }),
      (ShopifyAPI.changeItemQuantity = function(t, e) {
        return S.ajax({ type: 'post', dataType: 'json', url: '/cart/change.js', data: 'quantity=' + e + '&id=' + t })
      }),
      (ShopifyAPI.addItemToCart = function(t, e) {
        return S.ajax({ type: 'post', dataType: 'json', url: '/cart/add.js', data: 'quantity=' + e + '&id=' + t })
      }),
      (I.AjaxCart = (function() {
        var s = S(window),
          o = S('body'),
          n = '[data-ajax-cart-container]',
          a = 'script[data-ajax-cart-template]',
          r = '[data-ajax-cart-trigger]',
          l = '[data-ajax-cart-close]',
          t = 'form[action^="/cart/add"]',
          c = '[data-add-to-cart]',
          h = '[data-add-to-cart-text]',
          e = '[data-ajax-item][data-id][data-qty]',
          d = '[data-ajax-cart-item-remove]',
          u = '[data-ajax-cart-item-increment]',
          p = '[data-ajax-cart-item-decrement]',
          m = 'select[data-ajax-cart-item-quantity]',
          g = '[data-cart-badge]',
          f = '[data-cart-badge-count]',
          v = '[data-gift-product]',
          i = '[data-slideshow]',
          $ = 'ajax-cart-open',
          w = 'ajax-cart-backdrop',
          k = 'is-visible',
          b = 'is-open',
          C = 'has-items'
        function y() {
          ;(this.name = 'ajaxCart'),
            (this.namespace = '.' + this.name),
            (this.events = {
              RENDER: 'render' + this.namespace,
              DESTROY: 'destroy' + this.namespace,
              SCROLL: 'scroll' + this.namespace,
              UPDATE: 'update' + this.namespace,
            })
          var e = !(this.QUANTITY_SELECT_LIMIT = 10),
            i = { disableAjaxCart: !1 }
          return (
            (this.$el = S(n)),
            (this.$backdrop = null),
            (this.stateIsOpen = null),
            (this.giftProduct = 1 == S(v).length ? JSON.parse(S(v).html()) : ''),
            (this.transitionEndEvent = I.utils.whichTransitionEnd()),
            (this.hasGiftProduct = !1),
            (this.hasTriggerProduct = !1),
            (this.init = function(t) {
              if (!e) {
                if (((this.settings = S.extend(i, t)), S(a).length))
                  return (
                    (this.$container = S(n)),
                    (this.$cartBadge = S(g)),
                    (this.$cartBadgeCount = S(f)),
                    this._registerHelpers(T),
                    (this.template = T.compile(S(a).html())),
                    this.settings.disableAjaxCart || this._formOverride(),
                    o.on('click', r, this.onTriggerClick.bind(this)),
                    o.on('click', l, this.onCloseClick.bind(this)),
                    o.on('click', d, this.onItemRemoveClick.bind(this)),
                    o.on('click', u, this.onItemIncrementClick.bind(this)),
                    o.on('click', p, this.onItemDecrementClick.bind(this)),
                    o.on('change', m, this.onItemQuantitySelectChange.bind(this)),
                    s.on(this.events.RENDER, this.onCartRender.bind(this)),
                    s.on(this.events.DESTROY, this.onCartDestroy.bind(this)),
                    window.addEventListener('add-to-cart', (t) => {
                      ShopifyAPI.getCart().then((t) => {
                        this.onItemAddSuccess(t)
                      })
                    }),
                    this._checkCartStatus.call(this),
                    (e = !0)
                  )
                console.warn('[' + this.name + '] - Handlebars template required to initialize')
              }
            }),
            this
          )
        }
        return (
          (y.prototype = S.extend({}, y.prototype, {
            _checkCartStatus: function() {
              var i = this
              ShopifyAPI.getCart().then(function(t) {
                ;(i.hasGiftProduct = !1),
                  (i.hasTriggerProduct = !1),
                  S.each(t.items, function(t, e) {
                    void 0 !== i.giftProduct &&
                      (e.variant_id === i.giftProduct.variantId && (i.hasGiftProduct = !0),
                      null != i.giftProduct.triggerProductVariantIds &&
                        0 < i.giftProduct.triggerProductVariantIds.indexOf(e.variant_id) &&
                        (i.hasTriggerProduct = !0))
                  }),
                  1 == t.items.length
                    ? t.items[0].variant_id === i.giftProduct.variantId
                      ? i._removeGiftProduct.call(i)
                      : i.buildCart.call(i, t)
                    : 0 == i.hasTriggerProduct && 1 == i.hasGiftProduct
                    ? i._removeGiftProduct.call(i)
                    : i.buildCart.call(i, t)
              })
            },
            _formOverride: function() {
              var n = this
              o.on(
                'submit',
                t,
                function(t) {
                  t.preventDefault()
                  var e = S(t.target).find(c),
                    i = e.find(h)
                  e.prop('disabled', !0),
                    i.html(theme.strings.adding),
                    ShopifyAPI.addItemFromForm(S(t.target))
                      .then(function(t) {
                        e.prop('disabled', !1), i.html(theme.strings.addToCart), n._checkGiftProduct.call(n, t)
                      })
                      .fail(function(t) {
                        e.prop('disabled', !1), i.html(theme.strings.addToCart), n.onItemAddFail.call(n, t)
                      })
                }.bind(this)
              )
            },
            giftCarouselConditionalInit: function() {
              var t
              1 < S(i, this.$container).children().length &&
                ((t = {
                  fade: !1,
                  dots: !0,
                  arrows: !1,
                  mobileFirst: !0,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  cssEase: I.animations.getTransitionTimingFunction('inOutUI'),
                  speed: I.animations.getTransitionTimingDuration('slow'),
                }),
                (this.slideshow = new I.models.Slideshow(S(i, this.$container), t)))
            },
            _checkGiftProduct: function(t) {
              var i = this
              '' != i.giftProduct && '|XXX|' == i.giftProduct.triggerProductVariantIds
                ? (S.each(t.items, function(t, e) {
                    e.variant_id === i.giftProduct.variantId && (i.hasGiftProduct = !0)
                  }),
                  i.hasGiftProduct ? i.onItemAddSuccess.call(i, t) : i._addGiftProduct(i.giftProduct.variantId))
                : '' != i.giftProduct && 0 < i.giftProduct.triggerProductVariantIds.length
                ? ((i.hasGiftProduct = !1),
                  (i.hasTriggerProduct = !1),
                  S.each(t.items, function(t, e) {
                    e.variant_id === i.giftProduct.variantId && (i.hasGiftProduct = !0),
                      0 < i.giftProduct.triggerProductVariantIds.indexOf(e.variant_id) && (i.hasTriggerProduct = !0)
                  }),
                  0 == i.hasGiftProduct && 1 == i.hasTriggerProduct
                    ? i._addGiftProduct(i.giftProduct.variantId)
                    : i.onItemAddSuccess.call(i, t))
                : i.onItemAddSuccess.call(i, t)
            },
            _addGiftProduct: function(t) {
              var e = this
              ShopifyAPI.addItemToCart(t, 1).then(function() {
                ShopifyAPI.getCart().then(function(t) {
                  e.onItemAddSuccess(t)
                })
              })
            },
            _removeGiftProduct: function() {
              var e = this,
                t = e.giftProduct.variantId
              ShopifyAPI.changeItemQuantity(t, 0).then(function() {
                ShopifyAPI.getCart().then(function(t) {
                  e.buildCart.call(e, t)
                })
              })
            },
            _validateQty: function(t) {
              return parseFloat(t) != parseInt(t) || isNaN(t) ? 1 : t
            },
            _getItemRowAttributes: function(t) {
              ;(t = S(t)), (t = t.is(e) ? t : t.parents(e))
              return { $row: t, id: t.data('id'), qty: this._validateQty(t.data('qty')) }
            },
            _registerHelpers: function(t) {
              var h = this
              t.registerHelper('qty-select', function(t, e) {
                var i = S('<select />')
                i.addClass('form-control form-control--outlined'), i.attr('data-ajax-cart-item-quantity', '')
                var n = h.QUANTITY_SELECT_LIMIT,
                  s = '',
                  o = ''
                ;(t = parseInt(t) || 1),
                  e &&
                    e.metafields &&
                    e.metafields.labels &&
                    (null != e.metafields.labels.bulk_unit_name_singular &&
                      (s = e.metafields.labels.bulk_unit_name_singular),
                    null != e.metafields.labels.bulk_unit_name_plural &&
                      (o = e.metafields.labels.bulk_unit_name_plural)),
                  n <= t && (n = t + 10)
                for (var a = 1; a <= n; a++) {
                  var r = S('<option />'),
                    l = a,
                    c = a
                  ;(c += ' ' + I.utils.pluralize(a, s, o)), r.val(l), r.text(c), r.attr('selected', a == t), i.append(r)
                }
                return i.get(0).outerHTML
              })
            },
            addBackdrop: function(t) {
              var e = this,
                t = t || S.noop
              this.stateIsOpen
                ? ((this.$backdrop = S(document.createElement('div'))),
                  this.$backdrop.addClass(w).appendTo(o),
                  this.$backdrop.one(this.transitionEndEvent, t),
                  this.$backdrop.one('click', this.close.bind(this)),
                  setTimeout(function() {
                    e.$backdrop.addClass(k)
                  }, 10))
                : t()
            },
            removeBackdrop: function(t) {
              var e = this,
                i = t || S.noop
              !this.stateIsOpen && this.$backdrop
                ? (this.$backdrop.one(this.transitionEndEvent, function() {
                    e.$backdrop && e.$backdrop.remove(), (e.$backdrop = null), i()
                  }),
                  setTimeout(function() {
                    e.$backdrop.removeClass(k)
                  }, 10))
                : i()
            },
            onItemAddSuccess: function(t) {
              this.buildCart.call(this, t), this.open(), s.trigger(I.constants.cart.ajax.UPDATE, t)
            },
            onItemAddFail: function(t) {
              console.log('[' + this.name + '] - onItemAddFail'), console.warn('[' + this.name + '] - ' + t.message)
            },
            onCartRender: function(t) {
              I.utils.chosenSelects(this.$container)
            },
            onCartDestroy: function(t) {},
            buildCart: function(t) {
              var n = this
              ;(t.total_price = I.Currency.formatMoney(t.total_price, theme.moneyFormat)),
                t.items.map(function(t) {
                  var e, i
                  return (
                    (t.image = I.Image.getSizedImageUrl(t.image, '200x')),
                    (t.price = I.Currency.formatMoney(t.price, theme.moneyFormat)),
                    'Default Title' == t.variant_title && delete t.variant_title,
                    t.properties && t.properties.shipping_interval_frequency && t.properties.shipping_interval_unit_type
                      ? ((t.shipping_interval = 'deliver every '),
                        (t.shipping_interval +=
                          t.properties.shipping_interval_frequency + ' ' + t.properties.shipping_interval_unit_type))
                      : t.metafields &&
                        t.metafields.subscriptions &&
                        t.metafields.subscriptions.subscription_id &&
                        (t.shipping_interval = 'one-time purchase'),
                    t.metafields &&
                      t.metafields.labels &&
                      (t.metafields.bulk_quantity &&
                        t.metafields.bulk_quantity.quantity &&
                        t.metafields.labels.single_unit_name_singular &&
                        (e =
                          (e = t.quantity * t.metafields.bulk_quantity.quantity) +
                          ' ' +
                          I.utils.pluralize(
                            e,
                            t.metafields.labels.single_unit_name_singular,
                            t.metafields.labels.single_unit_name_plural
                          )),
                      t.metafields.labels.bulk_unit_name_singular &&
                        ((i = I.utils.pluralize(
                          t.quantity,
                          t.metafields.labels.bulk_unit_name_singular,
                          t.metafields.labels.bulk_unit_name_plural
                        )),
                        (i = t.quantity + ' ' + i)),
                      (i || e) &&
                        ((t.quantity_breakdown = ''),
                        i && (t.quantity_breakdown += i),
                        e && (t.quantity_breakdown += ' (' + e + ')'))),
                    void 0 !== n.giftProduct &&
                      t.variant_id === n.giftProduct.variantId &&
                      ((t.is_gift = !0), (t.is_hidden_product = !0)),
                    t
                  )
                }),
                s.trigger(n.events.DESTROY)
              var e = n.template(t)
              n.$container.empty().append(e),
                s.trigger(n.events.RENDER),
                s.trigger(n.events.UPDATE),
                n.updateCartCount(t),
                n.giftCarouselConditionalInit()
            },
            updateCartCount: function(t) {
              var e = parseInt(t.item_count)
              '' !== this.giftProduct && !1 === this.giftProduct.showGiftProductInCart && 1 < e
                ? this.$cartBadgeCount.html(e - 1)
                : this.$cartBadgeCount.html(e),
                t.item_count ? this.$cartBadge.addClass(C) : this.$cartBadge.removeClass(C)
            },
            onItemQuantitySelectChange: function(t) {
              var e = S(t.currentTarget),
                t = this._getItemRowAttributes(e.get(0)),
                e = this._validateQty(e.val()),
                i = this
              0 == e && t.$row.addClass('is-being-removed'),
                ShopifyAPI.changeItemQuantity(t.id, e)
                  .then(ShopifyAPI.getCart)
                  .then(function(t) {
                    i.buildCart.call(i, t), s.trigger(I.constants.cart.ajax.UPDATE, t)
                  })
            },
            onItemRemoveClick: function(t) {
              t.preventDefault()
              var t = this._getItemRowAttributes(t.target),
                e = this
              ShopifyAPI.changeItemQuantity(t.id, 0)
                .then(ShopifyAPI.getCart)
                .then(function(t) {
                  e._checkCartStatus(), s.trigger(I.constants.cart.ajax.UPDATE, t)
                })
            },
            onItemIncrementClick: function(t) {
              var e = this
              t.preventDefault(), console.log('[' + this.name + '] - onItemIncrementClick')
              t = this._getItemRowAttributes(t.target)
              ShopifyAPI.changeItemQuantity(t.id, t.qty + 1)
                .then(ShopifyAPI.getCart)
                .then(function(t) {
                  e.buildCart.call(e, t)
                })
            },
            onItemDecrementClick: function(t) {
              var e = this
              t.preventDefault(), console.log('[' + this.name + '] - onItemDecrementClick')
              var i = this._getItemRowAttributes(t.target),
                t = i.qty < 1 ? 0 : i.qty - 1
              ShopifyAPI.changeItemQuantity(i.id, t)
                .then(ShopifyAPI.getCart)
                .then(function(t) {
                  this.buildCart.bind(e, t)
                })
            },
            onTriggerClick: function(t) {
              t.preventDefault(), this.toggleVisibility()
            },
            onCloseClick: function(t) {
              t.preventDefault(), console.log('[' + this.name + '] - onCloseClick'), this.close()
            },
            toggleVisibility: function() {
              return this.stateIsOpen ? this.close() : this.open()
            },
            isOpen: function() {
              return this.stateIsOpen
            },
            isClosed: function() {
              return !this.stateIsOpen
            },
            open: function() {
              var t
              this.stateIsOpen ||
                ((this.stateIsOpen = !0),
                o.addClass($),
                this.$el.addClass(b),
                this.addBackdrop(),
                (t = {
                  $container: this.$el,
                  $elementToFocus: I.a11y.getFirstFocusableChild(this.$el),
                  namespace: 'cart',
                }),
                I.a11y.trapFocus(t))
            },
            close: function() {
              var t
              this.stateIsOpen &&
                ((this.stateIsOpen = !1),
                this.$el.removeClass(b),
                this.removeBackdrop(function() {
                  o.removeClass($)
                }),
                (t = { $container: this.$el, $element: S(r), namespace: 'cart' }),
                I.a11y.removeTrapFocus(t))
            },
          })),
          y
        )
      })())
  })(jQuery, Handlebars, slate),
  (slate.animations = (function(t) {
    t.extend(t.easing, {
      easeInQuint: function(t, e, i, n, s) {
        return n * (e /= s) * e * e * e * e + i
      },
      easeOutQuint: function(t, e, i, n, s) {
        return n * ((e = e / s - 1) * e * e * e * e + 1) + i
      },
      easeInOutQuint: function(t, e, i, n, s) {
        return (e /= s / 2) < 1 ? (n / 2) * e * e * e * e * e + i : (n / 2) * ((e -= 2) * e * e * e * e + 2) + i
      },
    })
    var i = { base: 300, fast: 150, fastest: 50, slow: 600, none: 0 },
      n = { base: 'ease-in-out', in: 'ease-out', out: 'ease-in', inOutUI: 'cubic-bezier(0.42, 0, 0.13, 1.04)' }
    return {
      getTransitionTimingDuration: function(t) {
        var e = 'base'
        return i.hasOwnProperty(t) && (e = t), i[e]
      },
      getTransitionTimingFunction: function(t) {
        var e = 'base'
        return n.hasOwnProperty(t) && (e = t), n[e]
      },
    }
  })(jQuery)),
  (slate.user = (function(i) {
    var n = '_soylent_'
    function t() {
      return (this.name = 'user'), (this.namespace = '.' + this.name), this
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        _cookies: {
          siteVisit: { name: n + 'site_visit', value: !0 },
          subscriptionSlideupSeen: { name: 'subscriptionSlideup_seen', value: !0 },
          subscriptionModalSeen: { name: 'subscriptionModal_seen', value: !0 },
          emailCollected: { name: 'emailCollected', value: !0 },
          gwpModalSeen: { name: 'gwpModalSeen', value: !0 },
        },
        generateCookie: function(t) {
          var e
          return (
            this._cookies.hasOwnProperty(t)
              ? ((e = $.extend(!0, {}, this._cookies[t])).name = n + e.name)
              : console.warn('[' + this.name + '] - Cannot create cookie.  Key "' + t + '" not found.'),
            e
          )
        },
        setCookie: function(t) {
          this.hasCookie(t.name) && this.getCookieValue(t.name) != t.value && this.removeCookie(t.name)
          var e = t.hasOwnProperty('expiration') ? { expires: t.expiration } : {}
          return i.set(t.name, t.value, e), this
        },
        hasCookie: function(t) {
          return void 0 !== i.get(t)
        },
        getCookieValue: function(t) {
          return this.hasCookie(t) ? i.get(t) : void 0
        },
        removeCookie: function(t) {
          return i.remove(t), this
        },
      })),
      new t()
    )
  })(Cookies)),
  (slate.breakpoints = (function(a) {
    var r = a(window),
      l = r.width(),
      c = { xs: 576, sm: 768, md: 992, lg: 1200, xl: 1480 },
      h = 'breakpointChange'
    return (
      r.on(
        'resize',
        a.throttle(20, function() {
          var o = r.width()
          a.each(c, function(t, e) {
            if ((e <= o && l < e) || (e <= l && o < e)) {
              ;(e =
                ((i = null != (i = o) ? i : r.width()),
                a.each(c, function(t, e) {
                  e < i ? (n = t) : (s = n)
                }),
                s)),
                (e = a.Event(h, { bpMinWidthKey: e }))
              return r.trigger(e), !1
            }
            var i, n, s
          }),
            (l = r.width())
        })
      ),
      {
        getBreakpointMinWidth: function(t) {
          if (t) return c.hasOwnProperty(t) ? c[t] : void 0
        },
      }
    )
  })(jQuery)),
  (slate.productCard = (function() {
    var e = '[data-product-card]',
      i = '[data-product-card-alt-lazy]',
      n = 'alt-loaded',
      s = window.PointerEvent
        ? { end: 'pointerup', focusin: 'focusin', focusout: 'focusout', enter: 'pointerenter', leave: 'pointerleave' }
        : { end: 'touchend', focusin: 'focusin', focusout: 'focusout', enter: 'mouseenter', leave: 'mouseleave' }
    function o(t) {
      var e = $(t.currentTarget),
        t = e.find(i)
      t.length &&
        (t.on('load', function() {
          e.addClass(n)
        }),
        t.attr('src', t.data('src')),
        t.removeAttr('data-src'))
    }
    $(document).ready(function() {
      var t = $(e)
      t.length && t.one(s.enter, o)
    })
  })()),
  (slate.ProductDetailForm = (function(u, a, p) {
    var r = '[data-mobile-select]',
      o = '[data-add-to-cart]',
      l = '[data-add-to-cart-text]',
      m = '[data-compare-price]',
      g = '[data-compare-text]',
      c = '[data-product-select]',
      h = '[data-price-wrapper]',
      f = '[data-product-price-frequency]',
      d = '[data-zoom-button]',
      v = '[data-product-gallery]',
      $ = '[data-product-gallery-slideshow]',
      i = '[data-product-gallery-slide-link]',
      w = '[data-product-gallery-thumbnail]',
      k = '[data-product-gallery-thumbnail-slide]',
      b = '[data-initial-slide]',
      n = '[data-customer-json]',
      C = '[data-product-price]',
      y = '[data-product-calculated-price]',
      S = '[data-product-onetime-price]',
      T = '[data-single-option-selector]',
      s = '[data-variant-option-value-list][data-option-position]',
      I = '[data-variant-option-value]',
      _ = '[data-product-quantity-input]',
      x = '[data-case-quantity-breakdown]',
      P = '[data-case-quantity-source]',
      e = '[data-price-per-serving]',
      E = '[data-full-details-link]',
      D = '#rc_container input[type="radio"][name="purchase_type"]',
      O = '.rc_block__autodeliver_options',
      M = '.rc_label__frequency',
      A = '.rc_select__frequency',
      F = 'hide',
      q = 'is-active',
      j = 'is-zoomable',
      N = 'is-zoomed',
      H = 'is-strike-through',
      B = u(window)
    function t(i) {
      var n = this
      ;(this.settings = {}),
        (this.name = 'productDetailForm'),
        (this.namespace = '.' + this.name),
        (this.subscribedPriceNumber = ''),
        (this.events = {
          RESIZE: 'resize' + this.namespace,
          CLICK: 'click' + this.namespace,
          READY: 'ready' + this.namespace,
          CHANGE: 'change' + this.namespace,
        })
      var s = !(this.rcPurchaseTypes = { AUTODELIVER: 'autodeliver', ONETIME: 'onetime' }),
        o = { enableZoom: !0, enableHistoryState: !0 }
      return (
        (this.initialize = function() {
          var t, e
          s ||
            ((this.settings = u.extend({}, o, i)),
            this.settings.$el && null != this.settings.$el
              ? ((this.$el = this.settings.$el),
                (this.$container = this.settings.$container),
                (this.$container && null != this.$container) || (this.$container = this.$el),
                (this.productSingleObject = window.BARREL.product),
                p.utils.chosenSelects(this.$container),
                (t = {
                  $container: this.$container,
                  enableHistoryState: this.settings.enableHistoryState,
                  singleOptionSelector: T,
                  originalSelectorId: c,
                  product: this.productSingleObject,
                }),
                (this.variants = new p.Variants(t)),
                this.$container.on('variantChange' + this.namespace, this.onVariantChange.bind(this)),
                this.initGalleries(),
                this.$container.on(this.events.CLICK, I, this.onVariantOptionValueClick.bind(this)),
                this.$container.on(
                  this.events.CHANGE,
                  _,
                  function(t) {
                    this.onQuantityInputChange(this.variants.currentVariant)
                  }.bind(this)
                ),
                this.$container.on(
                  this.events.CHANGE,
                  _,
                  function(t) {
                    this.$container.trigger({ type: 'variantChange', variant: this.variants.currentVariant })
                  }.bind(this)
                ),
                this.$container.on(this.events.CHANGE, D, this.onRcPurchaseTypeRadioInputChange.bind(this)),
                this.$container.on(this.events.CHANGE, A, this.onRcFrequencySelectChange.bind(this)),
                u('.chosen-container').on(this.events.CLICK, function(t) {
                  return t.preventDefault(), !1
                }),
                (e = u.Event(this.events.READY)),
                this.$el.trigger(e),
                (s = !0),
                u(D, this.$container)
                  .filter(':checked')
                  .val() == this.rcPurchaseTypes.AUTODELIVER &&
                  ((e = { currentTarget: u(D, this.$container).filter(':checked') }),
                  setTimeout(function() {
                    n.onRcPurchaseTypeRadioInputChange(e)
                  }, 100)),
                this.$container.on('change', r, this.onChangeFilter.bind(this)))
              : console.warn('[' + this.name + '] - $el required to initialize'))
        }),
        this
      )
    }
    return (
      (t.prototype = u.extend({}, t.prototype, {
        onChangeFilter: function(t) {
          t = u(t.currentTarget)
          window.location.href = t.val()
        },
        triggerCordialTracking: function() {
          var t = u(n, this.$container).html(),
            e = void 0 !== t ? JSON.parse(t) : null,
            t = window.BARREL.product
          B.trigger(p.constants.productDetailForm.READY, [t, e])
        },
        initGalleries: function() {
          var s = this,
            t = u(v, this.$container)
          function o(e) {
            var t = {
              url: e.find(i).attr('href'),
              on: 'mouseover',
              touch: !1,
              escToClose: !0,
              zoomMagnify: 0.8,
              zoomDuration: 300,
              callback: function() {
                e.addClass(j)
              },
              onZoomIn: function() {
                e.addClass(N)
              },
              onZoomOut: function() {
                e.removeClass(N)
              },
            }
            e.zoom(t),
              e.find(d).on('click', function(t) {
                return e.trigger('click'), !1
              })
          }
          function n(t, e, i, n) {
            ;(i = u(e.$slides[i])), (n = u(e.$slides[n]))
            s.settings.enableZoom && ((i = i).trigger('zoom.destroy'), i.find(d).off('click'), o(n))
          }
          t.each(function() {
            var t = u(this).find($),
              e = u(this).find(w),
              i = u(this).find(b).length
                ? u(this)
                    .find(b)
                    .index()
                : 0
            t.slick({
              lazyLoad: 'ondemand',
              speed: 600,
              dots: !1,
              swipe: a.touchevents,
              arrows: !0,
              asNavFor: '#' + e.attr('id'),
              prevArrow:
                '<button class="slick-arrow slick-arrow--prev" aria-label="product carousel previous image"><svg fill="none" viewBox="0 0 26 18" height="16" width="26"><g stroke="currentColor" stroke-width="1.5"><path d="M9.125 17.35l-8-8 8-8M25.125 9.35h-23"/></g></svg></button>',
              nextArrow:
                '<button class="slick-arrow slick-arrow--next" aria-label="product carousel next image"><svg fill="none" viewBox="0 0 26 18" height="16" width="26"><path d="M16.875 1.35l8 8-8 8M.875 9.35h23" stroke="currentColor" stroke-width="1.5"/></svg></button>',
              initialSlide: i,
              accessibility: !1,
              draggable: !0,
              responsive: [{ breakpoint: p.breakpoints.getBreakpointMinWidth('md'), settings: { dots: !0 } }],
            }),
              t.on('beforeChange', n),
              e.on('click', k, function() {
                t.slick('slickGoTo', u(this).data('slick-index'))
              }),
              e.slick({
                speed: 600,
                slidesToShow: 4 == e.find(k).length ? 3 : 4,
                slidestoScroll: 1,
                arrows: !1,
                asNavFor: '#' + t.attr('id'),
                initialSlide: i,
                accessibility: !1,
                draggable: !1,
                infinite: !1,
              }),
              ($amount_of_slides = u('.slick-track').length),
              $amount_of_slides < 3 && u(e).addClass('no-scroll-thumbnail')
          }),
            t.not('.hide').each(function() {
              var t = u(this)
              t
                .find($)
                .slick('getSlick')
                .refresh(),
                t
                  .find(w)
                  .slick('getSlick')
                  .refresh()
            })
        },
        resizeGalleries: function() {
          u('.slick-slider', this.$container).resize()
        },
        onVariantChange: function(t) {
          t = t.variant
          this.updateProductPrices(t),
            this.updateAddToCartState(t),
            this.updateQuantityInput(t),
            this.updateVariantOptionValues(t),
            this.updateFullDetailsLink(t),
            this.updateGalleries(t),
            this.updateQuantityDescription(t),
            this.updatePricePerServings(t),
            u(T, this.$container).trigger('chosen:updated')
        },
        updatePricePerServings: function(t) {
          u(e + '[data-variant-id="' + t.id + '"]', this.container).each(function(t) {
            var e = u(this).data('variant-price-per-serving')
            u(this)
              .closest('.rc_block')
              .find('.rc_price_breakdown')
              .text(e)
          })
        },
        updateQuantityDescription: function(t) {
          var e = u(_, this.$container).val(),
            t = '[data-variant-id="' + t.id + '"]',
            t = u(P + t, this.$container),
            e = parseFloat(t.data('case-quantity')) * e,
            t = t.data(1 == e ? 'unit-singular' : 'unit-plural')
          u(x, this.container).text(e + ' ' + t)
        },
        updateAddToCartState: function(t) {
          var e = u(o, this.$container),
            i = u(l, this.$container),
            n = u(h, this.$container),
            s = u(D, this.$container).filter(':checked')
          if (1 == this.productSingleObject.tags.indexOf('PREORDER'))
            return e.prop('disabled', !1), void i.html('Pre-order')
          if (!t) return e.prop('disabled', !0), i.html(theme.strings.unavailable), void n.addClass(F)
          n.removeClass(F)
          s =
            s.length && s.val() == this.rcPurchaseTypes.AUTODELIVER ? theme.strings.subscribe : theme.strings.addToCart
          t.available ? (e.prop('disabled', !1), i.html(s)) : (e.prop('disabled', !0), i.html(theme.strings.soldOut))
        },
        updateQuantityInput: function(t) {
          var e = u(_, this.$container)
          t && t.available ? e.prop('disabled', !1) : e.prop('disabled', !0)
        },
        updateProductPrices: function(t) {
          var e = u(C, this.$container),
            i = u(m, this.$container),
            n = u(S, this.$container),
            s = i.add(u(g, this.$container)),
            o = u(f, this.$container),
            a = u(D, this.$container).filter(':checked'),
            r = u(M, this.$container),
            l = u(A, this.$container),
            c = '',
            h = u(y, this.$container),
            d = u(_, this.$container).val()
          e.trigger('click'),
            (normalPriceMultiplied = t.price * d),
            (this.subscribedPriceNumber = parseFloat(e.text().replace(/\$/, '')))
          d = this.subscribedPriceNumber * d * 100
          'autodeliver' == a.val()
            ? (i.hide(),
              e.html(p.Currency.formatMoney(d, theme.moneyFormat)),
              h.html(p.Currency.formatMoney(d, theme.moneyFormat)),
              h.show(),
              n.addClass(H),
              n.html(p.Currency.formatMoney(normalPriceMultiplied, theme.moneyFormat)),
              d >= normalPriceMultiplied && n.hide(),
              r.length
                ? (c = '/ ' + r.text().trim())
                : l.length &&
                  (c =
                    '/ ' +
                    l
                      .find('option:selected')
                      .text()
                      .trim()))
            : (i.show(),
              n.html(p.Currency.formatMoney(normalPriceMultiplied, theme.moneyFormat)),
              h.hide(),
              n.removeClass(H),
              n.show()),
            o.text(c),
            t &&
              (t.compare_at_price > t.price
                ? (i.html(p.Currency.formatMoney(t.compare_at_price, theme.moneyFormat)), s.removeClass(F))
                : (i.html(''), s.addClass(F)))
        },
        updateVariantOptionValues: function(t) {
          if (t)
            for (var e = 3; 1 <= e; e--) {
              var i = t['option' + e],
                n = u(s, this.$container).filter('[data-option-position="' + e + '"]'),
                n = u('[data-variant-option-value="' + i + '"]', n)
              n.addClass(q), n.siblings().removeClass(q)
            }
        },
        updateFullDetailsLink: function(t) {
          var e = u(E, this.$container)
          t &&
            e.length &&
            ((t = p.utils.getUrlWithUpdatedQueryStringParameter('variant', t.id, e.attr('href'))), e.attr('href', t))
        },
        updateGalleries: function(t) {
          var e,
            i = u(v, this.$container)
          if (t)
            if (1 < i.length)
              for (var n = 3; 1 <= n; n--) {
                var s = (function(t) {
                  return i.filter(function() {
                    return u(this).data('variant-gallery') == t
                  })
                })(t['option' + n])
                s.length &&
                  s.hasClass(F) &&
                  (i.not(s).addClass(F),
                  s.removeClass(F),
                  s
                    .find($)
                    .slick('getSlick')
                    .refresh(),
                  s
                    .find(w)
                    .slick('getSlick')
                    .refresh())
              }
            else
              !t.featured_image ||
                i.find('.slick-current').data('image') == t.featured_image.id ||
                ((e = i.find('[data-image="' + t.featured_image.id + '"]').first()).length &&
                  i.find($).slick('slickGoTo', e.data('slick-index')))
        },
        onVariantOptionValueClick: function(t) {
          var e,
            i = u(t.currentTarget)
          i.hasClass(q) ||
            ((e = i.data('variant-option-value')),
            (t = i.parents(s).data('option-position')),
            (t = u(T, this.$container).filter('[data-index="option' + t + '"]')).val(e),
            t.trigger('change'),
            i.addClass(q),
            i.siblings().removeClass(q))
        },
        onQuantityInputChange: function(t) {
          this.updateQuantityDescription(t)
        },
        onRcFrequencySelectChange: function(t) {
          void 0 !== t && this.variants._onSelectChange()
        },
        onRcPurchaseTypeRadioInputChange: function(t) {
          var e, i
          void 0 !== t &&
            ((e = u(t.currentTarget).val()),
            (i = u(O, this.$container)),
            (t = { duration: 0, easing: 'easeInOutQuint' }),
            e == this.rcPurchaseTypes.AUTODELIVER ? i.slideDown(t) : i.slideUp(t),
            this.variants._onSelectChange())
        },
      })),
      t
    )
  })(jQuery, Modernizr, slate)),
  (slate.quickView = (function() {
    var t = $(window),
      e = $(document.body),
      i = '[data-quick-view-trigger]',
      a = '[data-product-card]'
    var n = new (function() {
      this.name = 'quickViewManager'
      var o = !(this.quickViews = [])
      return (
        (this.register = function(t) {
          if (t instanceof slate.models.QuickView) return this.quickViews.push(t), this
          console.warn('[' + this.name + '] - instance of slate.models.QuickView required when calling register')
        }),
        (this.getQuickViewByProductCard = function(i) {
          var n
          return (
            $.each(this.quickViews, function(t, e) {
              if (e.$productCard.is(i)) return (n = e), !1
            }),
            n
          )
        }),
        (this.onResize = function() {
          $.each(this.quickViews, function(t, e) {
            e.onResize()
          })
        }),
        (this.getOpenQuickViews = function() {
          var i = []
          return (
            $.each(this.quickViews, function(t, e) {
              e.isOpen() && i.push(e)
            }),
            i
          )
        }),
        (this.closeOpenQuickViews = function(i) {
          var t = this.getOpenQuickViews()
          0 == t.length
            ? i()
            : $.each(t, function(t, e) {
                0 == t && e.$productCard.one('closed.quickView', i), e.close()
              })
        }),
        (this.onQuickViewTriggerClick = function(t) {
          var e, i, n, s
          null != t &&
            ((e = this),
            (i = t.parents(a)),
            (n = this.getQuickViewByProductCard(i)),
            (s = t.text()),
            null == n
              ? o ||
                ((o = !0),
                t.text('Loading'),
                (n = new slate.models.QuickView({
                  $productCard: i,
                  url: t.attr('href'),
                  transitionDuration: slate.animations.getTransitionTimingDuration('slow'),
                  transitionTimingFunction: slate.animations.getTransitionTimingFunction('inOutUI'),
                })),
                i.one('loaded.quickView', function() {
                  ;(o = !1), t.text(s), e.closeOpenQuickViews(n.open.bind(n))
                }),
                e.register(n))
              : n.isOpen() || e.closeOpenQuickViews(n.open.bind(n)))
        }),
        t.on('resize', $.throttle(50, this.onResize.bind(this))),
        this
      )
    })()
    $(function() {
      e.on('click', i, function(t) {
        t.preventDefault(), n.onQuickViewTriggerClick($(this))
      })
    })
  })()),
  (slate.quantityAdjuster = (function() {
    var n = {
      adjuster: '[data-quantity-adjuster]',
      increment: '[data-increment]',
      decrement: '[data-decrement]',
      input: 'input[type="number"]',
    }
    $(document)
    function s(t) {
      ;(this.name = 'quantityAdjuster'),
        (this.namespace = '.' + this.name),
        (this.$el = $(t).is(n.adjuster) ? $(t) : $(t).parents(n.adjuster)),
        this.$el
          ? ((this.$increment = $(n.increment, this.$el)),
            (this.$decrement = $(n.decrement, this.$el)),
            (this.$input = $(n.input, this.$el)),
            (this.min = parseInt(this.$input.attr('min')) || 0),
            (this.max = parseInt(this.$input.attr('max')) || 999),
            this.$increment.on('click', this.onIncrementClick.bind(this)),
            this.$decrement.on('click', this.onDecrementClick.bind(this)),
            this.$input.on('change', this._updateDisabledState.bind(this)),
            this._updateDisabledState())
          : console.warn('[' + this.name + '] - Element required to initialize')
    }
    s.prototype = {
      _updateDisabledState: function() {
        var t = parseInt(this.$input.val())
        t == this.max
          ? (this.$increment.prop('disabled', !0), this.$decrement.prop('disabled', !1))
          : t == this.min
          ? (this.$increment.prop('disabled', !1), this.$decrement.prop('disabled', !0))
          : (this.$increment.prop('disabled', !1), this.$decrement.prop('disabled', !1))
      },
      _changeValue: function(t) {
        var e
        this.$input.is(':disabled') ||
          void 0 === t ||
          ((t = parseInt(t)),
          (t = (e = parseInt(this.$input.val())) + t) == e ||
            t > this.max ||
            t < this.min ||
            (this.$input.val(t), this.$input.trigger('change')))
      },
      onIncrementClick: function(t) {
        t.preventDefault(), this._changeValue(1)
      },
      onDecrementClick: function(t) {
        t.preventDefault(), this._changeValue(-1)
      },
    }
    var o = 'quantity-adjuster'
    function t() {
      $(n.adjuster).each(function(t, e) {
        var i
        ;(i = e),
          (e = $(i)),
          (i = (e = !e.is(n.adjuster) ? e.parents(n.adjuster) : e).data(o)) || e.data(o, (i = new s(e)))
      })
    }
    return (
      $(function() {
        t()
      }),
      { refresh: t }
    )
  })()),
  (slate.models = slate.models || {}),
  (slate.models.Dropdown = (function(e) {
    var t = 'is-open',
      i = 'is-forced-open'
    function n(t) {
      ;(this.$trigger = t),
        (this.$el = e(this.$trigger.data('dropdown-trigger'))),
        (this.$triggerClose = this.$el.find('[data-dropdown-close]')),
        (this.blockId = this.$trigger.data('block').toString())
    }
    return (
      (n.prototype = {
        isOpen: function() {
          return this.$el.hasClass(t)
        },
        open: function() {
          this.$trigger.attr('aria-expanded', 'true'), this.$el.addClass(t), this.$el.attr('aria-expanded', 'true')
        },
        close: function() {
          this.$trigger.attr('aria-expanded', 'false'), this.$el.removeClass(t), this.$el.attr('aria-expanded', 'false')
        },
        forceOpen: function() {
          this.$el.addClass(i)
        },
        forceClose: function() {
          this.$el.removeClass(i)
        },
      }),
      n
    )
  })(jQuery)),
  (slate.models = slate.models || {}),
  (slate.models.DropdownManager = (function(t) {
    function e() {
      ;(this.closeDropdownTimeout = null),
        (this.closeDropdownTimeoutDuration = 80),
        (this.dropdowns = []),
        (this.activeDropdown = void 0),
        (this.events = window.PointerEvent
          ? { end: 'pointerup', enter: 'pointerenter', leave: 'pointerleave', click: 'click' }
          : { end: 'touchend', enter: 'mouseenter', leave: 'mouseleave', click: 'click' })
    }
    return (
      (e.prototype = {
        register: function(t) {
          t = new slate.models.Dropdown(t)
          t.$trigger.on(this.events.enter, this.onTriggerMouseEnter.bind(this, t)),
            t.$trigger.on(this.events.leave, this.onTriggerMouseLeave.bind(this, t)),
            t.$trigger.on(this.events.end, this.onTriggerTouchEnd.bind(this, t)),
            t.$trigger.on(this.events.click, this.onTriggerClick.bind(this, t)),
            t.$triggerClose.on(this.events.click, this.onTriggerClick.bind(this, t)),
            t.$el.on(this.events.leave, this.onDropdownMouseLeave.bind(this, t)),
            t.$el.on(this.events.enter, this.onDropdownMouseEnter.bind(this, t)),
            t.$el.on(this.events.end, this.onDropdownTouchEnd.bind(this, t)),
            this.dropdowns.push(t)
        },
        getDropdownByBlockId: function(t) {
          return slate.utils.findInstance(this.dropdowns, 'blockId', t)
        },
        onTriggerMouseEnter: function(t, e) {
          'touch' != e.pointerType && (this.stopCloseTimeout(), this.openDropdown(t))
        },
        onTriggerMouseLeave: function(t, e) {
          'touch' != e.pointerType && this.startCloseTimeout(t)
        },
        onTriggerTouchEnd: function(t, e) {
          e.preventDefault(), e.stopPropagation(), this.toggleDropdown(t)
        },
        onTriggerClick: function(t, e) {
          e.preventDefault(), e.stopPropagation(), this.toggleDropdown(t)
        },
        onDropdownMouseEnter: function(t, e) {
          'touch' != e.pointerType && this.stopCloseTimeout()
        },
        onDropdownMouseLeave: function(t, e) {
          'touch' != e.pointerType && this.startCloseTimeout(t)
        },
        onDropdownTouchEnd: function(t, e) {
          e.stopPropagation()
        },
        toggleDropdown: function(t) {
          return this.activeDropdown == t ? this.closeDropdown(t) : this.openDropdown(t)
        },
        openDropdown: function(t) {
          this.activeDropdown !== t && (this.closeAllDropdowns(), (this.activeDropdown = t).open())
        },
        closeDropdown: function(t) {
          t.close(), this.activeDropdown == t && (this.activeDropdown = void 0)
        },
        closeAllDropdowns: function() {
          t.each(this.dropdowns, function(t, e) {
            e.isOpen() && e.close()
          }),
            (this.activeDropdown = void 0)
        },
        startCloseTimeout: function(t) {
          this.closeDropdownTimeout = setTimeout(this.closeDropdown.bind(this, t), this.closeDropdownTimeoutDuration)
        },
        stopCloseTimeout: function() {
          clearTimeout(this.closeDropdownTimeout)
        },
      }),
      e
    )
  })(jQuery)),
  (slate.models = slate.models || {}),
  (slate.models.Drawer = (function(o, i) {
    var t = o(document),
      n = o(document.body),
      s = '[data-drawer-close]',
      a = 'drawer',
      e = 'is-visible',
      r = 'drawer-backdrop',
      l = 'is-visible',
      c = 'drawer-open'
    function h(t, e) {
      ;(this.name = 'drawer'),
        (this.namespace = '.' + this.name),
        (this.$el = o(t)),
        (this.$backdrop = null),
        (this.stateIsOpen = !1),
        (this.transitionEndEvent = slate.utils.whichTransitionEnd()),
        (this.supportsCssTransitions = i.hasOwnProperty('csstransitions') && i.csstransitions),
        null != this.$el && this.$el.hasClass(a)
          ? ((t = { closeSelector: s, backdrop: !0 }),
            (this.settings = o.extend({}, t, e)),
            (this.events = {
              HIDE: 'hide' + this.namespace,
              HIDDEN: 'hidden' + this.namespace,
              SHOW: 'show' + this.namespace,
              SHOWN: 'shown' + this.namespace,
            }),
            this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this)))
          : console.warn('[' + this.name + '] - Element with class `' + a + '` required to initialize.')
    }
    return (
      (h.prototype = o.extend({}, h.prototype, {
        addBackdrop: function(t) {
          var e = this,
            t = t || o.noop
          this.stateIsOpen
            ? ((this.$backdrop = o(document.createElement('div'))),
              this.$backdrop.addClass(r).appendTo(n),
              this.$backdrop.one(this.transitionEndEvent, t),
              this.$backdrop.one('click', this.hide.bind(this)),
              setTimeout(function() {
                n.addClass(c), e.$backdrop.addClass(l)
              }, 10))
            : t()
        },
        removeBackdrop: function(t) {
          var e = this,
            i = t || o.noop
          this.$backdrop
            ? (this.$backdrop.one(this.transitionEndEvent, function() {
                e.$backdrop && e.$backdrop.remove(), (e.$backdrop = null), i()
              }),
              setTimeout(function() {
                e.$backdrop.removeClass(l), n.removeClass(c)
              }, 10))
            : i()
        },
        onHidden: function() {
          this.stateIsOpen = !1
          var t = o.Event(this.events.HIDDEN)
          this.$el.trigger(t)
        },
        onShown: function() {
          var t = o.Event(this.events.SHOWN)
          this.$el.trigger(t)
        },
        hide: function() {
          var t = o.Event(this.events.HIDE)
          this.$el.trigger(t),
            this.stateIsOpen &&
              (this.$el.removeClass(e),
              this.settings.backdrop && this.removeBackdrop(),
              this.supportsCssTransitions
                ? this.$el.one(this.transitionEndEvent, this.onHidden.bind(this))
                : this.onHidden())
        },
        show: function() {
          var t = o.Event(this.events.SHOW)
          this.$el.trigger(t),
            this.stateIsOpen ||
              ((this.stateIsOpen = !0),
              this.$el.addClass(e),
              this.settings.backdrop && this.addBackdrop(),
              this.supportsCssTransitions
                ? this.$el.one(this.transitionEndEvent, this.onShown.bind(this))
                : this.onShown())
        },
        toggle: function() {
          return this.stateIsOpen ? this.hide() : this.show()
        },
        onCloseClick: function(t) {
          t.preventDefault(), this.hide()
        },
      })),
      t.on('click.drawer', '[data-toggle="drawer"]', function(t) {
        var e = o(this),
          i = o(e.attr('data-target')),
          n = o.extend(i.data(), e.data()),
          s = e.data('drawer')
        e.is('a') && t.preventDefault(), s ? s.toggle() : (e.data('drawer', (s = new h(i, n))), s.show())
      }),
      h
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.Slideshow = (function(i) {
    var n = '[data-slideshow-wrapper]',
      s = '[data-slideshow]',
      e = '[data-slideshow-slide]'
    function t(t, e) {
      t = i(t)
      ;(this.$wrapper = t.is(n) ? t : t.closest(n)),
        (this.$slideshow = this.$wrapper.find(s)),
        this.isInitialized() || this.$slideshow.slick(e)
    }
    return (
      (t.prototype = i.extend({}, t.prototype, {
        destroy: function() {
          return this.$slideshow.slick('unslick')
        },
        isInitialized: function() {
          return this.$slideshow.hasClass('slick-initialized')
        },
        goToSlideByBlockId: function(t) {
          t = i(e, this.$slideshow).filter('[data-block-id="' + t + '"]:not(.slick-cloned)')
          this.$slideshow.slick('slickGoTo', t.data('slick-index'))
        },
      })),
      t
    )
  })(jQuery)),
  (slate.models = slate.models || {}),
  (slate.models.PressQuoteSlideshow = (function(e) {
    var i = '[data-slideshow]',
      n = '.press-quote-logo-list',
      s = '.press-quote-logo-list__item',
      o = 'is-active',
      a = e(window)
    function t(t) {
      ;(this.$el = e(t)),
        (this.$slideshow = e(i, this.$el)),
        (this.$logoListItems = e(s, this.$el)),
        (this.$logoList = e(n, this.$el)),
        (this.logoListBreakpoint = slate.breakpoints.getBreakpointMinWidth('sm')),
        (this.interactivityTimeout = void 0),
        this.$el.on('click', '.slick-arrow', this.onSlickArrowClick.bind(this)),
        this.$slideshow.on('beforeChange', this.onSlideshowBeforeChange.bind(this)),
        this.$logoList.on('beforeChange', this.onLogoListBeforeChange.bind(this)),
        this.$logoListItems.on('click', this.onLogoListItemClick.bind(this)),
        a.on('resize', e.throttle(50, this.onResize.bind(this))),
        this.initSlideShows()
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        initSlideShows: function() {
          this.$slideshow.hasClass('slick-initialized') ||
            this.$slideshow.slick({
              prevArrow: this.$el.find('.slick-arrow--prev').first(),
              nextArrow: this.$el.find('.slick-arrow--next').first(),
              cssEase: 'cubic-bezier(0.42, 0.11, 0.12, 0.92)',
              speed: 300,
              mobileFirst: !0,
              autoplay: !0,
              autoplaySpeed: 6e3,
              swipe: !1,
              accessibility: !1,
              responsive: [{ breakpoint: slate.breakpoints.getBreakpointMinWidth('md'), settings: { speed: 500 } }],
            }),
            !this.$logoList.hasClass('slick-initialized') &&
              window.innerWidth < this.logoListBreakpoint &&
              this.$logoList.slick({
                infinite: !1,
                autoplay: !1,
                arrows: !1,
                accessibility: !1,
                initialSlide: this.$slideshow.slick('slickCurrentSlide') || 0,
              })
        },
        setInteractivityTimeout: function() {
          this.$slideshow.slick('slickPause'),
            clearTimeout(this.interactivityTimeout),
            (this.interactivityTimeout = setTimeout(
              function() {
                this.$slideshow.slick('slickPlay')
              }.bind(this),
              2e3
            ))
        },
        onSlideshowBeforeChange: function(t, e, i, n) {
          var s = this.$logoListItems.eq(n)
          this.$logoListItems.removeClass(o),
            this.$logoList.hasClass('slick-initialized') && this.$logoList.slick('slickGoTo', n),
            setTimeout(function() {
              s.addClass(o)
            }, 150)
        },
        onLogoListBeforeChange: function(t, e, i, n) {
          this.$slideshow.slick('slickGoTo', n)
        },
        onLogoListItemClick: function(t) {
          t.preventDefault()
          t = e(t.currentTarget).index()
          this.$slideshow.slick('slickGoTo', t),
            this.$logoList.hasClass('slick-initialized') && this.$logoList.slick('slickGoTo', t),
            this.setInteractivityTimeout()
        },
        onSlickArrowClick: function(t) {
          this.setInteractivityTimeout()
        },
        onResize: function() {
          window.innerWidth < this.logoListBreakpoint
            ? this.initSlideShows()
            : this.$logoList.hasClass('slick-initialized') &&
              (this.$logoList.slick('unslick'), this.$logoListItems.attr('tabindex', ''))
        },
      })),
      t
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.Timeline = (function(e, i) {
    var n = 'progress',
      s = '[data-timeline-background]',
      o = '[data-timeline-text-slideshow]',
      a = '[data-timeline-image-slideshow]',
      r = '[data-timeline-marker-slideshow]',
      l = '.timeline-marker[data-marker-index]',
      c = '.timeline-marker-highlight',
      h = '[data-next]',
      d = '[data-prev]',
      u = 'is-active'
    function t(t) {
      ;(this.$el = e(t)),
        (this.$progress = e(n, this.$el)),
        (this.$background = e(s, this.$el)),
        (this.$textSlideshow = e(o, this.$el)),
        (this.$imageSlideshow = e(a, this.$el)),
        (this.$markerSlideshow = e(r, this.$el)),
        (this.$markers = e(l, this.$el)),
        (this.$markerHighlight = e(c, this.$el)),
        (this.$currentMarker = this.$markers.eq(0)),
        (this.$prev = e(d, this.$el)),
        (this.$next = e(h, this.$el)),
        (this.baseOpacity = 35),
        (this.markerSlideshowBreakpoint = slate.breakpoints.getBreakpointMinWidth('sm')),
        (this.transformProperty = (i && i.prefixedCSS('transform')) || 'transform'),
        this.$imageSlideshow.on('beforeChange', this.onImageSlideshowBeforeChange.bind(this)),
        this.$markerSlideshow.on('beforeChange', this.onMarkerSlideshowBeforeChange.bind(this)),
        this.$imageSlideshow.slick({
          mobileFirst: !0,
          fade: !1,
          arrows: !1,
          swipe: !0,
          accessibility: !1,
          adaptiveHeight: !0,
          responsive: [
            { breakpoint: slate.breakpoints.getBreakpointMinWidth('md'), settings: { fade: !0, swipe: !1 } },
          ],
        }),
        this.$textSlideshow.slick({ fade: !0, arrows: !1, accessibility: !1, adaptiveHeight: !0 }),
        this.$markers.on('click', this.onMarkerClick.bind(this)),
        this.$prev.on('click', this.onPrevClick.bind(this)),
        this.$next.on('click', this.onNextClick.bind(this)),
        e(window).on('resize', e.throttle(100, this.onResize.bind(this))),
        this.updateProgressForIndex(0),
        this.onResize()
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        updateProgressForIndex: function(t) {
          var e = Math.round(((t + 1) / this.$markers.length) * 100),
            i = (100 - this.baseOpacity) * (e / 100),
            n = Math.round(this.baseOpacity + i),
            n = slate.utils.clamp(n, 0, 100)
          ;(n *= 0.01), (this.$currentMarker = this.$markers.eq(t))
          t = function() {
            this.$progress.val(e),
              this.$background.css('opacity', n),
              this.$markerSlideshow.hasClass('slick-initialized')
                ? this.adjustMarkerHighlightWidth()
                : (this.adjustMarkerHighlightWidth(), this.placeMarkerHighlight()),
              this.$el.find(l).removeClass(u),
              this.$currentMarker.addClass(u)
          }
          window.requestAnimationFrame ? requestAnimationFrame(t.bind(this)) : t()
        },
        adjustMarkerHighlightWidth: function() {
          this.$markerHighlight.css('width', this.$currentMarker.outerWidth())
        },
        placeMarkerHighlight: function() {
          this.$markerHighlight.css(
            this.transformProperty,
            'translateX(' + this.$currentMarker.get(0).offsetLeft + 'px)'
          )
        },
        onImageSlideshowBeforeChange: function(t, e, i, n) {
          this.$textSlideshow.slick('slickGoTo', n),
            this.$markerSlideshow.hasClass('slick-initialized') && this.$markerSlideshow.slick('slickGoTo', n),
            this.updateProgressForIndex(n)
        },
        onMarkerSlideshowBeforeChange: function(t, e, i, n) {
          this.$imageSlideshow.slick('slickGoTo', n)
        },
        onMarkerClick: function(t) {
          t = e(t.currentTarget).data('marker-index')
          this.$textSlideshow.slick('slickGoTo', t), this.$imageSlideshow.slick('slickGoTo', t)
        },
        onPrevClick: function() {
          this.$textSlideshow.slick('slickPrev'),
            this.$imageSlideshow.slick('slickPrev'),
            this.$markerSlideshow.hasClass('slick-initialized') &&
              (this.$markerSlideshow.slick('slickPrev'), this.adjustMarkerHighlightWidth())
        },
        onNextClick: function() {
          this.$textSlideshow.slick('slickNext'),
            this.$imageSlideshow.slick('slickNext'),
            this.$markerSlideshow.hasClass('slick-initialized') &&
              (this.$markerSlideshow.slick('slickNext'), this.adjustMarkerHighlightWidth())
        },
        onResize: function() {
          var t
          window.innerWidth < this.markerSlideshowBreakpoint
            ? ((t = []),
              5 <= this.$markers.length &&
                t.push({ breakpoint: slate.breakpoints.getBreakpointMinWidth('xs'), settings: { slidesToShow: 5 } }),
              this.$markerSlideshow.hasClass('slick-initialized') ||
                (this.$markerSlideshow.slick({
                  centerMode: !0,
                  centerPadding: '0px',
                  focusOnSelect: !0,
                  slidesToShow: 3,
                  swipeToSlide: !0,
                  arrows: !1,
                  accessibility: !1,
                  mobileFirst: !0,
                  adaptiveHeight: !0,
                  responsive: t,
                }),
                this.$markerHighlight.css({ left: '50%', transform: 'translateX(-50%)' })),
              this.adjustMarkerHighlightWidth())
            : (this.$markerSlideshow.hasClass('slick-initialized') &&
                (this.$markerSlideshow.slick('unslick'), this.$markerHighlight.css('left', 0)),
              this.adjustMarkerHighlightWidth(),
              this.placeMarkerHighlight())
        },
      })),
      t
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.Slideup = (function(o, i) {
    var t = o(document),
      n = '[data-slideup-close]',
      s = 'slideup',
      e = 'is-visible'
    function a(t, e) {
      ;(this.name = 'slideup'),
        (this.namespace = '.' + this.name),
        (this.$el = o(t)),
        (this.stateIsOpen = !1),
        (this.transitionEndEvent = slate.utils.whichTransitionEnd()),
        (this.supportsCssTransitions = i.hasOwnProperty('csstransitions') && i.csstransitions),
        null != this.$el && this.$el.hasClass(s)
          ? ((t = { closeSelector: n }),
            (this.settings = o.extend({}, t, e)),
            (this.events = {
              HIDE: 'hide' + this.namespace,
              HIDDEN: 'hidden' + this.namespace,
              SHOW: 'show' + this.namespace,
              SHOWN: 'shown' + this.namespace,
            }),
            this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this)))
          : console.warn('[' + this.name + '] - Element with class `' + s + '` required to initialize.')
    }
    return (
      (a.prototype = o.extend({}, a.prototype, {
        onHidden: function() {
          var t = o.Event(this.events.HIDDEN)
          this.$el.trigger(t)
        },
        onShown: function() {
          var t = o.Event(this.events.SHOWN)
          this.$el.trigger(t)
        },
        hide: function() {
          var t = o.Event(this.events.HIDE)
          this.$el.trigger(t),
            this.stateIsOpen &&
              ((this.stateIsOpen = !1),
              this.$el.removeClass(e),
              this.supportsCssTransitions
                ? this.$el.one(this.transitionEndEvent, this.onHidden.bind(this))
                : this.onHidden())
        },
        show: function() {
          var t = o.Event(this.events.SHOW)
          this.$el.trigger(t),
            this.stateIsOpen ||
              ((this.stateIsOpen = !0),
              this.$el.addClass(e),
              this.supportsCssTransitions
                ? this.$el.one(this.transitionEndEvent, this.onShown.bind(this))
                : this.onShown())
        },
        toggle: function() {
          return this.stateIsOpen ? this.hide() : this.show()
        },
        onCloseClick: function(t) {
          t.preventDefault(), this.hide()
        },
      })),
      t.on('click.slideup', '[data-toggle="slideup"]', function(t) {
        var e = o(this),
          i = o(e.attr('data-target')),
          n = o.extend(i.data(), e.data()),
          s = e.data('slideup')
        e.is('a') && t.preventDefault(), s ? s.toggle() : (e.data('slideup', (s = new a(i, n))), s.show())
      }),
      a
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.SlideupAlert = (function(i) {
    var n = i(document.body),
      s = 'script[data-slideup-template]'
    function t(t) {
      var e
      ;(this.name = 'slideupAlert'),
        (this.namespace = '.' + this.name),
        i(s).length
          ? ((e = Handlebars.compile(i(s).html())),
            (this.settings = i.extend({}, { title: null, text: null, timeoutDuration: 5e3 }, t)),
            (this.interactionTimeout = !1),
            (this.$el = i(e(this.settings))),
            this.$el.appendTo(n),
            this.$el.on('shown.slideup', this.onShown.bind(this)),
            this.$el.on('hidden.slideup', this.onHidden.bind(this)),
            this.$el.on('mouseenter', this.onMouseenter.bind(this)),
            this.$el.on('mouseleave', this.onMouseleave.bind(this)),
            (this.slideup = new slate.models.Slideup(this.$el)),
            setTimeout(
              function() {
                this.slideup.show()
              }.bind(this),
              10
            ))
          : console.warn('[' + this.name + '] - Handlebars template required to initialize')
    }
    return (
      (t.prototype = i.extend({}, t.prototype, {
        setInteractionTimeout: function() {
          this.interactionTimeout = setTimeout(
            function() {
              this.slideup.hide()
            }.bind(this),
            this.settings.timeoutDuration
          )
        },
        clearInteractionTimeout: function() {
          clearTimeout(this.interactionTimeout)
        },
        onMouseenter: function() {
          this.clearInteractionTimeout()
        },
        onMouseleave: function() {
          this.setInteractionTimeout()
        },
        onHidden: function() {
          this.clearInteractionTimeout(), this.$el.remove()
        },
        onShown: function() {
          this.setInteractionTimeout()
        },
      })),
      t
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.Overlay = (function(o, i) {
    var e = o(document),
      n = o(document.body),
      s = '[data-overlay-close]',
      a = 'overlay',
      r = 'is-visible',
      l = 'overlay-open'
    function c(t, e) {
      ;(this.name = 'overlay'),
        (this.namespace = '.' + this.name),
        (this.$el = o(t)),
        (this.stateIsOpen = !1),
        (this.transitionEndEvent = slate.utils.whichTransitionEnd()),
        (this.supportsCssTransitions = i.hasOwnProperty('csstransitions') && i.csstransitions),
        null != this.$el && this.$el.hasClass(a)
          ? ((t = { closeSelector: s }),
            (this.settings = o.extend({}, t, e)),
            (this.events = {
              HIDE: 'hide' + this.namespace,
              HIDDEN: 'hidden' + this.namespace,
              SHOW: 'show' + this.namespace,
              SHOWN: 'shown' + this.namespace,
              FOCUS: 'focus' + this.namespace,
              KEYDOWN_DISMISS: 'keydown.dismiss' + this.namespace,
            }),
            this.$el.on('click', this.settings.closeSelector, this.onCloseClick.bind(this)))
          : console.warn('[' + this.name + '] - Element with class `' + a + '` required to initialize.')
    }
    return (
      (c.prototype = o.extend({}, c.prototype, {
        onHidden: function() {
          n.removeClass(l)
          var t = o.Event(this.events.HIDDEN)
          this.$el.trigger(t)
        },
        onShown: function() {
          this.enforceFocus()
          var t = o.Event(this.events.SHOWN)
          this.$el.trigger(t), this.$el.trigger('focus')
        },
        hide: function() {
          var t = o.Event(this.events.HIDE)
          this.$el.trigger(t),
            this.stateIsOpen &&
              ((this.stateIsOpen = !1),
              this.updateEscapeHandler(),
              e.off(this.events.FOCUS),
              this.$el.removeClass(r),
              this.supportsCssTransitions
                ? this.$el.one(this.transitionEndEvent, this.onHidden.bind(this))
                : this.onHidden())
        },
        show: function() {
          var t = o.Event(this.events.SHOW)
          this.$el.trigger(t),
            this.stateIsOpen ||
              ((this.stateIsOpen = !0),
              this.updateEscapeHandler(),
              n.addClass(l),
              this.$el.addClass(r),
              this.supportsCssTransitions
                ? this.$el.one(this.transitionEndEvent, this.onShown.bind(this))
                : this.onShown())
        },
        enforceFocus: function() {
          e.off(this.events.FOCUS),
            e.on(
              this.events.FOCUS,
              o.proxy(function(t) {
                document === t.target ||
                  this.$element[0] === t.target ||
                  this.$element.has(t.target).length ||
                  this.$el.trigger('focus')
              }, this)
            )
        },
        updateEscapeHandler: function() {
          this.stateIsOpen
            ? this.$el.on(
                this.events.KEYDOWN_DISMISS,
                o.proxy(function(t) {
                  27 == t.which && this.hide()
                }, this)
              )
            : this.$el.off(this.events.KEYDOWN_DISMISS)
        },
        toggle: function() {
          return this.stateIsOpen ? this.hide() : this.show()
        },
        onCloseClick: function(t) {
          t.preventDefault(), this.hide()
        },
      })),
      e.on('click.overlay', '[data-toggle="overlay"]', function(t) {
        var e = o(this),
          i = o(e.attr('data-target')),
          n = o.extend(i.data(), e.data()),
          s = e.data('overlay')
        e.is('a') && t.preventDefault(), s ? s.toggle() : (e.data('overlay', (s = new c(i, n))), s.show())
      }),
      c
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.QuickView = (function(i, n) {
    var e = '[data-quick-view]',
      s = '[data-quick-view-contents-body]',
      o = '[data-quick-view-close]',
      a = '[data-product-card-contents]',
      r = '[data-product-detail-form]',
      l = 'is-open',
      c = 'has-open-quick-view'
    function t(t) {
      ;(this.name = 'quickView'), (this.namespace = '.' + this.name)
      var e = { onProductDetailFormReady: i.noop, transitionDuration: 800, transitionTimingFunction: 'ease-in-out' }
      if (((this.settings = i.extend({}, e, t)), null != typeof this.settings.$productCard)) {
        if (
          'string' == typeof this.settings.url &&
          0 != this.settings.url.length &&
          -1 != this.settings.url.indexOf('quick-view')
        )
          return (
            (this.$productCard = this.settings.$productCard),
            (this.$productCardContents = this.$productCard.find(a)),
            (this.$productDetailForm = null),
            (this.$quickView = null),
            (this.$quickViewContentsBody = null),
            (this.$close = null),
            (this.stateIsOpen = !1),
            (this.supportsCssTransitions = n.hasOwnProperty('csstransitions') && n.csstransitions),
            (this.productDetailFormInstance = null),
            (this.events = {
              OPEN: 'open' + this.namespace,
              OPENED: 'opened' + this.namespace,
              CLOSE: 'close' + this.namespace,
              CLOSED: 'closed' + this.namespace,
              LOADED: 'loaded' + this.namespace,
            }),
            this.$productCard.on('click', o, this.onCloseClick.bind(this)),
            this.$productCard.height(this.$productCardContents.outerHeight(!0)),
            i.get(this.settings.url, this._onAjaxSuccess.bind(this)),
            this
          )
        console.warn('[' + this.name + '] - valid URL required to initialize')
      } else console.warn('[' + this.name + '] - $productCard element required to initialize')
    }
    return (
      (t.prototype = {
        _onAjaxSuccess: function(t) {
          this.$productCard.append(i(t)),
            (this.$productDetailForm = this.$productCard.find(r)),
            (this.$quickView = this.$productCard.find(e)),
            (this.$quickViewContentsBody = this.$productCard.find(s)),
            (this.$close = this.$quickView.find(o)),
            this.$productDetailForm.on('ready.productDetailForm', this.onProductDetailFormReady.bind(this))
          t = { $el: this.$productDetailForm, zoomEnabled: !0, enableHistoryState: !1 }
          ;(this.productDetailFormInstance = new slate.ProductDetailForm(t)),
            this.productDetailFormInstance.initialize(),
            this.$quickView.imagesLoaded().always(
              function() {
                var t = i.Event(this.events.LOADED)
                this.$productCard.trigger(t)
              }.bind(this)
            )
        },
        onProductDetailFormReady: function() {
          this.settings.onProductDetailFormReady.call(this)
        },
        open: function() {
          this.onOpen(), this.isOpen() || ((this.stateIsOpen = !0), this.doOpenAnimation())
        },
        close: function() {
          this.onClose(), this.isClosed() || ((this.stateIsOpen = !1), this.doCloseAnimation())
        },
        isOpen: function() {
          return this.stateIsOpen
        },
        isClosed: function() {
          return !this.isOpen()
        },
        onOpen: function() {
          this.$productCard.addClass(c)
          var t = i.Event(this.events.OPEN)
          this.$productCard.trigger(t)
        },
        onClose: function() {
          this.$productCard.removeClass(c)
          var t = i.Event(this.events.CLOSE)
          this.$productCard.trigger(t)
        },
        onOpened: function() {
          var t = i.Event(this.events.OPENED)
          this.$productCard.trigger(t)
        },
        onClosed: function() {
          var t = i.Event(this.events.CLOSED)
          this.$productCard.trigger(t), this.$quickView.removeClass(l)
        },
        doOpenAnimation: function() {
          this.$quickView.addClass(l)
          var t = this.$productCardContents.outerHeight(!0),
            e = this.$quickViewContentsBody.outerHeight(!0)
          this.$productCard.height(t),
            this.$quickView.height(0),
            this.setTransitions(),
            this.$productCard.height(t + e),
            this.$quickView.height(e),
            this.supportsCssTransitions
              ? this.$quickView.one(slate.utils.whichTransitionEnd(), this.onOpened.bind(this))
              : this.onOpened()
        },
        doCloseAnimation: function() {
          this.stateIsOpen = !1
          var t = this.$productCardContents.outerHeight(!0)
          this.$productCard.height(t),
            this.$quickView.height(0),
            this.supportsCssTransitions
              ? this.$quickView.one(slate.utils.whichTransitionEnd(), this.onClosed.bind(this))
              : this.onClosed()
        },
        onResize: function() {
          var t = this.$quickViewContentsBody.outerHeight(!0),
            e = this.$productCardContents.outerHeight(!0)
          this.isClosed() ? this.$productCard.height(e) : (this.$productCard.height(e + t), this.$quickView.height(t))
        },
        setTransitions: function() {
          var t = 'height ' + this.settings.transitionDuration + 'ms ' + this.settings.transitionTimingFunction
          this.$quickView.css('transition', t), this.$productCard.css('transition', t)
        },
        scrollToProductCard: function() {
          i('html, body').animate({ scrollTop: this.$productCard.offset().top - 100 })
        },
        scrollToQuickView: function() {
          i('html, body').animate({ scrollTop: this.$quickView.offset().top })
        },
        onCloseClick: function(t) {
          t.preventDefault(), this.close()
        },
      }),
      t
    )
  })(jQuery, Modernizr)),
  (slate.models = slate.models || {}),
  (slate.models.CollectionFilters = (function() {
    $(document.body)
    var i = '[data-filters-type][data-filters-type-select]',
      n = '[data-mobile-filter-group]',
      s = '[data-mobile-filter-tag][data-mobile-filter-type]',
      o = '[data-mobile-filter-apply]',
      a = 'is-selected'
    function t(t, e) {
      ;(this.$container = $(t)),
        (this.name = 'collectionFilters'),
        (this.namespace = '.' + this.name),
        e &&
          ((this.collectionData = e),
          (this.$filterSelects = $(i, this.$container)),
          (this.$mobileFilterTags = $(s, this.$container)),
          this.$container.on('change', i, this.onFilterSelectChange.bind(this)),
          this.$container.on('click', s, this.onMobileFilterTagClick.bind(this)),
          this.$container.on('click', o, this.onMobileFilterApplyClick.bind(this)),
          this._sortFilters())
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        _getCollectionUrlWithTags: function(t) {
          var e = this.collectionData.url
          return (t = (t = t || []).map(function(t) {
            return t
              .toLowerCase()
              .replace(/[^\w\u00C0-\u024f]+/g, '-')
              .replace(/^-+|-+$/g, '')
          })).length
            ? e + '/' + t.join('+')
            : e
        },
        _getSelectedTags: function() {
          return $.map(this.$filterSelects.find('option:selected'), function(t, e) {
            if ($(t).val()) return $(t).val()
          })
        },
        _getSelectedMobileTags: function() {
          return $.map(this.$mobileFilterTags, function(t, e) {
            if ($(t).hasClass(a)) return $(t).data('mobile-filter-tag')
          })
        },
        _sortingFunctions: {
          size: function(t, e) {
            console.warn("[collectionFilters] - _sortingFunctions.size - This method hasn't been implemented yet.")
          },
        },
        _sortFilters: function() {
          var n = this
          this.$filterSelects.each(function() {
            var t = $(this),
              e = t.find('option'),
              i = n._sortingFunctions[t.data('filters-type')]
            i &&
              e.sort(function(t, e) {
                return i($(t).val(), $(e).val())
              })
          })
        },
        redirect: function(t) {
          window.location.href = t + slate.utils.getQueryString()
        },
        clear: function() {
          window.location.href = this.collectionData.url + slate.utils.getQueryString()
        },
        onFilterSelectChange: function(t) {
          var e = this._getSelectedTags(),
            e = this._getCollectionUrlWithTags(e)
          this.redirect(e)
        },
        onMobileFilterTagClick: function(t) {
          t.preventDefault()
          var e = $(t.currentTarget),
            t = e.hasClass(a)
          e
            .parents(n)
            .find(s)
            .removeClass(a),
            t || e.addClass(a)
        },
        onMobileFilterApplyClick: function(t) {
          t.preventDefault()
          ;(t = this._getSelectedMobileTags()), (t = this._getCollectionUrlWithTags(t))
          this.redirect(t)
        },
      })),
      t
    )
  })()),
  (slate.models.CollectionSort = (function() {
    $(document.body)
    var i = '[data-sort-select]'
    function t(t, e) {
      ;(this.$container = $(t)),
        (this.name = 'collectionSort'),
        (this.namespace = '.' + this.name),
        e && ((this.collectionData = e), this.$container.on('change', i, this.applySort.bind(this)))
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        applySort: function() {
          var t = $(i, this.container)
              .find('option:selected')
              .val(),
            e = slate.utils.getQueryParams()
          t !== this.collectionData.sortDefault ? (e.sort_by = t) : delete e.sort_by, (location.search = $.param(e))
        },
      })),
      t
    )
  })()),
  (theme.Product = (function(e, i) {
    var n = '[data-add-to-cart-form]',
      s = '[data-add-to-cart-form-wrapper]',
      o = '[data-add-gwp-to-cart-form]',
      a = '[data-gwp-variant-selector]',
      r = '[data-gwp-product-image-display]',
      l = '[data-gwp-product-title-display]',
      c = '[data-gwp-product-description-display]',
      h = '.pr-snippet-review-count',
      d = '.section-tab-container',
      u = (e(window), e(document))
    function t(t) {
      ;(this.$container = e(t)),
        (this.settings = {}),
        (this.name = 'product'),
        (this.namespace = '.' + this.name),
        (this.$addToCartFormWrapper = e(s, this.$container)),
        (this.$addToCartForm = e(n, this.$container)),
        (this.$addGiftAndProductToCart = e(o, this.$container))
      t = new i.ProductDetailForm({
        $el: this.$container,
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || !1,
        enableZoom: this.$container.data('zoom-enabled') || !1,
      })
      ;(this.cookies = {}),
        (this.cookies.gwpModalSeen = i.user.generateCookie('gwpModalSeen')),
        (this.cookies.gwpModalSeen.expiration = isNaN(parseInt(this.$container.data('seen-expiration')))
          ? 30
          : parseInt(this.$container.data('seen-expiration'))),
        e(document).on('mouseout', this.triggerModal.bind(this)),
        e(o).on('submit', this.addProductAndGiftToCart.bind(this)),
        e(a).on('change', this.onGWPVariantChanged.bind(this)),
        u.on('click', h, this.onReviewsClick.bind(this)),
        t.initialize()
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        triggerModal: function(t) {
          null === t.toElement &&
            null === t.relatedTarget &&
            (i.user.hasCookie(this.cookies.gwpModalSeen.name) ||
              i.utils.isThemeEditor() ||
              (e(t.currentTarget).off('mouseout'),
              e('#modal--exit-intent').modal('show'),
              i.utils.isThemeEditor() || i.user.setCookie(this.cookies.gwpModalSeen)))
        },
        onGWPVariantChanged: function(t) {
          t = e(t.target)
            .children('option:selected')
            .data()
          e(l).text(t.gwpTitle), e(c).text(t.gwpDescription), e(r).attr('src', t.gwpImageUrl)
        },
        addProductAndGiftToCart: function(t) {
          return e('#modal--exit-intent').modal('hide'), !0
        },
        onReviewsClick: function(t) {
          0 < e(d).length &&
            (t.preventDefault(), e(window).trigger({ type: 'pdp_show_tab_section_of_type', sectionType: 'reviews' }))
        },
      })),
      t
    )
  })(jQuery, slate)),
  (theme.Collection = (function(e) {
    var i = '[data-collection-json]'
    function t(t) {
      ;(this.$container = $(t)),
        (this.name = 'collection'),
        (this.namespace = '.' + this.name),
        $(i, this.$container).html()
          ? ((this.collectionData = JSON.parse($(i, this.$container).html())),
            (this.filters = new e.models.CollectionFilters(t, this.collectionData)),
            (this.sort = new e.models.CollectionSort(t, this.collectionData)))
          : console.warn('[' + this.name + '] - Element matching ' + i + ' required.')
    }
    return (t.prototype = $.extend({}, t.prototype, {})), t
  })(slate)),
  (theme.PencilBanner = (function(e) {
    var t = e(window),
      i = '[data-slideshow]',
      n = '[data-slideshow-slide]',
      s = '[data-slideshow-wrapper]',
      o = '[data-pencil-banner-close]',
      a = '[data-about-us-carousel-arrow-prev]',
      r = '[data-about-us-carousel-arrow-next]'
    function l(t) {
      ;(this.$container = e(t)),
        (this.name = 'pencilBanner'),
        (this.namespace = '.' + this.name),
        (this.events = { SHOW: 'show' + this.namespace, CLOSE: 'close' + this.namespace }),
        (this.$slideshowSlides = e(n, this.$container)),
        (this.$slideshowWrapper = e(s, this.$container))
      e(i, this.$container).data()
      t = {
        dots: !1,
        autoplay: !1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: !1,
        mobileFirst: !0,
        fade: !0,
        swipe: !1,
        arrows: !0,
        prevArrow: e(a, this.$container),
        nextArrow: e(r, this.$container),
        infinite: !0,
        cssEase: 'ease',
        accessibility: !1,
        responsive: [],
      }
      this.$slideshowSlides.length < 2 ||
        ((this.slideshow = new slate.models.Slideshow(this.$slideshowWrapper, t)),
        e(o).on('click', this.close.bind(this)))
    }
    return (
      (l.prototype = e.extend({}, l.prototype, {
        initForThemeEditor: function() {
          slate.utils.isThemeEditor()
        },
        show: function() {
          console.log('[' + this.name + '] - open'), t.trigger(e.Event(this.events.SHOW))
        },
        close: function() {
          console.log('[' + this.name + '] - close'), t.trigger(e.Event(this.events.CLOSE))
        },
        onCloseClick: function(t) {
          t.preventDefault(), this.close()
        },
        onSelect: function() {
          console.log('[' + this.name + '] - section:select')
        },
        onShow: function() {
          console.log('[' + this.name + '] - section:show')
        },
        onLoad: function() {
          console.log('[' + this.name + '] - section::load')
        },
        onUnload: function() {
          console.log('[' + this.name + '] - section::unload')
        },
      })),
      l
    )
  })(jQuery)),
  (theme.InstagramFeed = (function(e, i) {
    var n = '[data-instagram-feed-target]',
      s = 'script[data-instagram-media-template]',
      o = '[data-slideshow-wrapper]',
      a = '.slick-dots'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'instagramFeed'),
        (this.namespace = '.' + this.name),
        (this.$target = e(n, this.$container)),
        (this.template = Handlebars.compile(e(s).html())),
        (this.settings = {
          accessToken: this.$container.attr('data-access-token'),
          get: 'user',
          mock: !0,
          success: this.onInstafeedMockSuccess.bind(this),
          limit: this.$container.attr('data-limit') || 8,
        }),
        (this.slickSettings = {
          dots: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: !1,
          fade: !1,
          arrows: !1,
          adaptiveHeight: !0,
        }),
        this.settings.accessToken
          ? this.init()
          : console.warn('[InstagramFeed] - An access token is required to interact with the Instagram API')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        init: function() {
          e.ajax({
            type: 'GET',
            url: 'https://api.instagram.com/v1/users/self?access_token=' + this.settings.accessToken,
            dataType: 'jsonp',
          }).then(
            function(t) {
              t.meta.hasOwnProperty('error_message')
                ? console.warn('[' + this.name + '] - ' + t.meta.error_message)
                : ((this.settings.userId = t.data.id), (this.feed = new i(this.settings)), this.feed.run())
            }.bind(this)
          )
        },
        onInstafeedMockSuccess: function(t) {
          var i = this
          t.data.forEach(function(t, e) {
            t = {
              url: t.link,
              src: t.images && t.images.standard_resolution && t.images.standard_resolution.url,
              caption: (t.caption && t.caption.text) || '',
            }
            i.$target.append(i.template(t))
          }),
            (this.slideshow = new slate.models.Slideshow(e(o, this.$container), this.slickSettings)),
            e(a, this.$container)
              .css({ position: 'relative' })
              .css({ top: '-48px' })
        },
        onSelect: function() {
          console.log('[' + this.name + '] - section:select')
        },
        onShow: function() {
          console.log('[' + this.name + '] - section:show')
        },
        onLoad: function() {
          console.log('[' + this.name + '] - section::load')
        },
        onUnload: function() {
          console.log('[' + this.name + '] - section::unload')
        },
      })),
      t
    )
  })(jQuery, Instafeed)),
  (theme.Slideshow = (function(e) {
    var i = '[data-slideshow-wrapper]'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'slideshow'),
        (this.namespace = '.' + this.name),
        e(i, this.$container).length
          ? (this.slideshow = new slate.models.Slideshow(e(i, this.$container), {}))
          : console.warn('[' + this.name + '] - Element matching ' + i + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        onBlockSelect: function(t) {
          this.slideshow.goToSlideByBlockId(t.detail.blockId), this.slideshow.pause()
        },
      })),
      t
    )
  })(jQuery)),
  (theme.Header = (function(n) {
    var s = n(window),
      e = n(document.body),
      o = '[data-header]',
      a = '[data-dropdown-trigger][data-block]',
      r = '[data-mobile-nav]',
      l = '[data-mobile-nav-toggle]',
      c = '[data-submenu-trigger][data-block]',
      h = '[data-submenu]',
      d = '.nav-header-hover-trg',
      i = '.header-dropdown__nav',
      u = '[data-country-selector-trigger]',
      p = '[data-country-dropdown]',
      m = 'is-open',
      g = 'is-fixed',
      f = 'site-fixed-header',
      t = 'is-active',
      v = 'is-active',
      $ = 'is-active',
      w = 'mobile-nav-subnav-open'
    function k(t) {
      var i = this
      ;(this.$container = n(t)),
        (this.$el = n(o, this.$container)),
        (this.name = 'header'),
        (this.namespace = '.' + this.name),
        (this.dropdownManager = new slate.models.DropdownManager()),
        (this.siteHasFixedHeader = e.hasClass(f)),
        (this.countrySelectorOpen = !1),
        (this.mobileNavOpen = !1),
        (this.submenuOpen = !1),
        (this.desktopBreakpoint = slate.breakpoints.getBreakpointMinWidth('md')),
        (this.transitionEndEvent = slate.utils.whichTransitionEnd()),
        (this.supportsCssTransitions = Modernizr.hasOwnProperty('csstransitions') && Modernizr.csstransitions),
        (this.selectedBlock = null),
        (this.$mobileNav = n(r, this.$container)),
        (this.$mobileNavToggle = n(l, this.$container)),
        (this.$submenus = n(h, this.$container)),
        (this.$submenusTriggers = n(c, this.$container)),
        (this.$dropdownImage = n(d, this.$container)),
        (this.events = { SCROLL: 'scroll' + this.namespace, RESIZE: 'resize' + this.namespace }),
        n(a, this.$container).each(function(t, e) {
          i.dropdownManager.register(n(e))
        }),
        n(a, this.$container).on('click', function(t) {
          t.preventDefault()
        }),
        this.$container.on('pointerleave mouseleave', this.onMouseLeave.bind(this)),
        this.$container.on('click', l, this.onMobileNavToggleClick.bind(this)),
        this.$container.on('click', c, this.onSubmenuTriggerClick.bind(this)),
        this.$container.on('mouseenter mouseleave click', u, this.onToggleCountrySelector.bind(this)),
        s.on(this.events.RESIZE, n.throttle(20, this.onResize.bind(this))),
        s.on(this.events.SCROLL, n.throttle(20, this.onScroll.bind(this))),
        s.on('breakpointChange', this.onBreakpointChange.bind(this)),
        this.onScroll(),
        this.onResize(),
        this.$dropdownImage.on('mouseenter', this.onSiblingEnter.bind(this)),
        this.$dropdownImage.on('mouseleave', this.onSiblingLeave.bind(this))
    }
    return (
      (k.prototype = n.extend({}, k.prototype, {
        onToggleCountrySelector: function(t) {
          this.countrySelectorOpen ? this.closeCountrySelectorDropdown(t) : this.openCountrySelectorDropdown(t)
        },
        openCountrySelectorDropdown: function(t) {
          t = n(t.currentTarget)
          n(p, t).addClass(m), (this.countrySelectorOpen = !0)
        },
        closeCountrySelectorDropdown: function(t) {
          t = n(t.currentTarget)
          n(p, t).removeClass(m), (this.countrySelectorOpen = !1)
        },
        scrollCheck: function() {
          var t, e
          this.siteHasFixedHeader &&
            ((t = s.scrollTop()),
            (e = this.$container.offset().top - this.$el.outerHeight()),
            requestAnimationFrame(
              function() {
                t < e ? this.$el.removeClass(g) : this.$el.addClass(g)
              }.bind(this)
            ))
        },
        openMobileNav: function() {
          ;(this.mobileNavOpen = !0),
            this.$mobileNav.addClass(t),
            this.$mobileNavToggle.addClass(v),
            e.addClass('js-mobile-nav-open')
        },
        closeMobileNav: function() {
          var t = this.onMobileNavClose.bind(this)
          this.closeSubmenus(), t(), e.removeClass('js-mobile-nav-open')
        },
        toggleMobileNav: function() {
          return this.mobileNavOpen ? this.closeMobileNav() : this.openMobileNav()
        },
        openSubmenu: function(t) {
          ;(this.submenuOpen = !0), t.slideDown(), t.addClass($), e.addClass(w), this.resizeMobileNav()
        },
        closeSubmenus: function(t) {
          void 0 !== t
            ? (t.removeClass($), t.slideUp(), e.removeClass(w))
            : (this.$submenus.removeClass($),
              this.$submenusTriggers.parent().removeClass($),
              this.$submenus.slideUp(),
              e.removeClass(w),
              (this.submenuOpen = !1))
        },
        resizeMobileNav: function() {},
        onMobileNavClose: function() {
          this.$mobileNav.removeClass(t),
            this.$mobileNavToggle.removeClass(v),
            this.$submenus.off(this.transitionEndEvent),
            e.removeClass(w),
            (this.mobileNavOpen = !1)
        },
        onScroll: function() {
          this.scrollCheck()
        },
        onResize: function() {
          this.resizeMobileNav(),
            this.selectedBlock &&
              (s.width() > this.desktopBreakpoint
                ? this.openSelectedBlockDropdown(this.selectedBlock)
                : this.openSelectedBlockSubmenu(this.selectedBlock))
        },
        onBreakpointChange: function(t) {
          s.width() > this.desktopBreakpoint && (this.closeMobileNav(), this.onMobileNavClose())
        },
        onMouseLeave: function() {
          this.dropdownManager.closeAllDropdowns()
        },
        onMobileNavToggleClick: function(t) {
          t.preventDefault(), this.toggleMobileNav()
        },
        onSubmenuTriggerClick: function(t) {
          t.preventDefault()
          var e = n(t.currentTarget),
            i = n(e.data('submenu-trigger')),
            t = e.parent().hasClass(v)
          t ? (this.closeSubmenus(i), e.parent().removeClass($)) : (this.openSubmenu(i), e.parent().addClass($)),
            e.attr('aria-expanded', !t)
        },
        _openBlockElement: function(t) {
          var e
          null != t &&
            ((e = this.dropdownManager.getDropdownByBlockId(t)),
            (t = this.$submenus.filter('[data-block="' + t + '"')),
            s.width() > this.desktopBreakpoint ? e && e.forceOpen() : (this.openMobileNav(), this.openSubmenu(t)))
        },
        _closeBlockElement: function(t) {
          var e
          null != t &&
            ((e = this.dropdownManager.getDropdownByBlockId(t)),
            (t = this.$submenus.filter('#submenu-' + t)),
            s.width() > this.desktopBreakpoint ? e && e.forceClose() : t && this.closeSubmenus())
        },
        onSiblingEnter: function(t) {
          t.preventDefault()
          var e = n(t.currentTarget),
            t = n(e)
              .parent()
              .siblings(i)
              .find('.header-dropdown__nav-title'),
            e = n(e)
              .parent()
              .siblings('.cta')
          t.addClass('image-hovering'), e.addClass('image-hovering')
        },
        onSiblingLeave: function(t) {
          t.preventDefault()
          var e = n(t.currentTarget),
            t = n(e)
              .parent()
              .siblings(i)
              .find('.header-dropdown__nav-title'),
            e = n(e)
              .parent()
              .siblings('.cta')
          t.removeClass('image-hovering'), e.removeClass('image-hovering')
        },
        onBlockSelect: function(t) {
          ;(this.selectedBlock = t.detail.blockId), this._openBlockElement(this.selectedBlock)
        },
        onBlockDeselect: function(t) {
          ;(this.selectedBlock = null), this._closeBlockElement(t.detail.blockId)
        },
        onDeselect: function() {
          this.closeMobileNav()
        },
      })),
      k
    )
  })(jQuery)),
  (theme.Footer = (function(i) {
    var e = '[data-navigation-toggler]',
      n = '[data-navigation]',
      s = 'is-open'
    function t(t) {
      ;(this.$container = i(t)),
        (this.name = 'footer'),
        (this.namespace = '.' + this.name),
        (this.$menuToggler = i(e, this.$container)),
        (this.$menuContent = i(n, this.$container)),
        i(e, this.$container).on('click', this.onToggleMenu.bind(this))
    }
    return (
      (t.prototype = i.extend({}, t.prototype, {
        onToggleMenu: function(t) {
          var e = i(t.currentTarget),
            t = e.data('navigation-toggler'),
            t = i('[data-navigation=' + t + ']')
          e.hasClass(s)
            ? (e.toggleClass(s), t.slideToggle())
            : (this.$menuToggler.removeClass(s), this.$menuContent.slideUp(), e.addClass(s), t.slideDown())
        },
        onSelect: function() {
          console.log('[' + this.name + '] - section:select')
        },
        onShow: function() {
          console.log('[' + this.name + '] - section:show')
        },
        onLoad: function() {
          console.log('[' + this.name + '] - section::load')
        },
        onUnload: function() {
          console.log('[' + this.name + '] - section::unload')
        },
      })),
      t
    )
  })(jQuery)),
  (theme.AjaxCart = (function(i) {
    var n = i(document.body)
    function t(t) {
      ;(this.$container = i(t)),
        (this.name = 'ajaxCart'),
        (this.namespace = '.' + this.name),
        (this.ajaxCart = new slate.AjaxCart()),
        n.hasClass('template-cart') || this.ajaxCart.init()
      var e = this
      i(window).on(slate.constants.cart.ajax.REFRESH, function() {
        e.ajaxCart._checkCartStatus()
      })
    }
    return (
      (t.prototype = i.extend({}, t.prototype, {
        onSelect: function() {
          this.ajaxCart.open()
        },
        onDeselect: function() {
          this.ajaxCart.close()
        },
        onShow: function() {},
        onLoad: function() {},
        onUnload: function() {},
      })),
      t
    )
  })(jQuery)),
  (theme.Cart = (function(n) {
    var i = n(window),
      e = '[data-item-quantity-select]',
      s = '[data-remove-item]',
      o = '[data-gift-product]'
    function t(t) {
      ;(this.$container = n(t)),
        (this.name = 'footer'),
        (this.namespace = '.' + this.name),
        (this.giftProduct = 1 == n(o).length ? JSON.parse(n(o).html()) : ''),
        this.$container.on('change', e, this.updateLineItemQty.bind(this)),
        this.$container.on('click', s, this.onRemoveItemClick.bind(this))
    }
    return (
      (t.prototype = n.extend({}, t.prototype, {
        updateLineItemQty: function(t) {
          var e = this,
            i = n(t.currentTarget),
            t = i.data('item-key'),
            i = i.val()
          ShopifyAPI.changeItemQuantity(t, i).then(function() {
            ShopifyAPI.getCart().then(function(t) {
              1 == t.items.length && t.items[0].variant_id === e.giftProduct.variantId
                ? e._removeGiftProduct.call(e)
                : location.reload()
            })
          })
        },
        onRemoveItemClick: function(t) {
          t.preventDefault(), t.stopPropagation()
          var e = this,
            t = { id: t.currentTarget.getAttribute('data-variant-id') }
          ShopifyAPI.changeItemQuantity(t.id, 0).then(function() {
            ShopifyAPI.getCart().then(function(t) {
              1 == t.items.length && t.items[0].variant_id === e.giftProduct.variantId
                ? e._removeGiftProduct.call(e)
                : location.reload()
            })
          }),
            i.trigger(slate.constants.cart.ajax.REMOVE, [t])
        },
        _removeGiftProduct: function() {
          var t = this.giftProduct.variantId
          ShopifyAPI.changeItemQuantity(t, 0).then(function() {
            ShopifyAPI.getCart().then(function(t) {
              location.reload()
            })
          })
        },
      })),
      t
    )
  })(jQuery)),
  (theme.Blog = (function(s) {
    var o = '.content-grid',
      a = '.content-grid__item',
      r = '[data-pagination]',
      l = '[data-next-page]',
      e = '[data-mobile-select]',
      c = s('footer').offset().top
    function t(t) {
      ;(this.$container = s(t)),
        (this.name = 'blog'),
        (this.namespace = '.' + this.name),
        slate.utils.chosenSelects(this.$container),
        s(window).on('scroll', s.debounce(250, this.onPageScroll.bind(this))),
        this.$container.on('change', e, this.onChangeFilter.bind(this))
    }
    return (
      (t.prototype = s.extend({}, t.prototype, {
        onPageScroll: function(t) {
          var i,
            n,
            e = s(window).height() + s(window).scrollTop()
          c <= e &&
            1 == s(l).length &&
            'Load More' != s(l).text &&
            ((e = (n = s(l, (i = this).$container)).attr('href')),
            s
              .ajax({
                url: e,
                beforeSend: function() {
                  n.addClass('load-more--loading'), n.html(theme.strings.loading || 'Loading')
                },
              })
              .done(function(t) {
                var e = s(t),
                  t = s(a, e),
                  e = s(l, e)
                s(o, i.$container).append(t), e.length ? n.replaceWith(e) : s(r, i.$container).remove()
              }))
        },
        onChangeFilter: function(t) {
          t = s(t.currentTarget)
          window.location.href = t.val()
        },
      })),
      t
    )
  })(jQuery)),
  (theme.Clp = (function(e) {
    function t(t) {
      ;(this.$container = e(t)), (this.name = 'clp'), (this.namespace = '.' + this.name)
    }
    return (t.prototype = e.extend({}, t.prototype, {})), t
  })(jQuery)),
  (theme.Hero = (function(e) {
    var i = e(window),
      n = '[data-hero]',
      s = '[data-scroll-to-next-section]',
      o = '[data-video-container]',
      a = '[data-video-frame]',
      r = '[data-video-id]',
      l = 'is-playing'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'hero'),
        (this.namespace = '.' + this.name),
        (this.$hero = e(n, this.$container))
      t = { RESIZE: 'resize' + this.namespace }
      ;(this.aspectWeb = this.$container.data('aspect-web') || 'auto'),
        (this.aspectMobile = this.$container.data('aspect-mob') || 'auto')
      ;(this.$videoContainers = e(o)),
        this.$videoContainers.map(function() {
          var t = e(a, this)
          new Vimeo.Player(t, {
            id: e(r, this).data().videoId,
            loop: e(r, this).data().videoLoop,
            background: !0,
            autoplay: !0,
            controls: !1,
            muted: !0,
          }).on('pause', function() {
            t.removeClass(l)
          })
        }),
        this.$container.on('click', s, this.autoScrolltoID.bind(this)),
        i.on(t.RESIZE, e.throttle(20, this.onResize.bind(this)))
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        autoScrolltoID: function(t) {
          t.preventDefault()
          t = e(t.target)
            .closest('.shopify-section')
            .next()
          e('html, body').animate({ scrollTop: t.offset().top - 90 }, { duration: 1e3 })
        },
        onResize: function() {},
      })),
      t
    )
  })(jQuery)),
  (theme.DynamicText = (function(e) {
    var i = { textSlider: '[data-text-slider]', slides: '[data-text-slide]' }
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'dynamicText'),
        (this.namespace = '.' + this.name),
        e(i.textSlider, this.$container).length
          ? e(i.slides, this.$container).length
            ? (this.slideshow = e(i.textSlider, this.$container).slick({
                vertical: !0,
                arrows: !1,
                dots: !1,
                autoplay: !0,
              }))
            : console.warn('[' + this.name + '] - Element matching ' + i.slide + ' required to initialize')
          : console.warn('[' + this.name + '] - Element matching ' + i.textSlider + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        onSelect: function() {
          console.log('[' + this.name + '] - section:select')
        },
        onShow: function() {
          console.log('[' + this.name + '] - section:show')
        },
        onLoad: function() {
          console.log('[' + this.name + '] - section::load')
        },
        onUnload: function() {
          console.log('[' + this.name + '] - section::unload')
        },
      })),
      t
    )
  })(jQuery)),
  (theme.IconographicModule = (function(e) {
    var i = '[data-slideshow]',
      n = e(window)
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'iconographicModule'),
        (this.namespace = '.' + this.name),
        e(i, this.$container).length
          ? ((this.settings = { dots: !0, autoplay: !0, fade: !1, arrows: !1, speed: 500 }),
            (this.breakpoint = slate.breakpoints.getBreakpointMinWidth('md')),
            n.on('breakpointChange', this.onBreakpointChange.bind(this)),
            this.onBreakpointChange())
          : console.warn('[' + this.name + '] - Element matching ' + i + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        initializeSlider: function() {
          ;(this.slideshow && this.slideshow.isInitialized()) ||
            (this.slideshow = new slate.models.Slideshow(e(i, this.$container), this.settings))
        },
        destroySlider: function() {
          null != this.slideshow && (this.slideshow.destroy(), (this.slideshow = null))
        },
        onBreakpointChange: function(t) {
          n.width() < this.breakpoint ? this.initializeSlider() : this.destroySlider()
        },
        onBlockSelect: function(t) {
          this.slideshow.goToSlideByBlockId(t.detail.blockId), this.slideshow.pause()
        },
      })),
      t
    )
  })(jQuery)),
  (theme.ArticleGrid = (function(e) {
    var i = '[data-slideshow-wrapper]'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'articleGrid'),
        (this.namespace = '.' + this.name),
        e(i, this.$container).length
          ? e(window).width() < slate.breakpoints.getBreakpointMinWidth('md') &&
            (this.slideshow = new slate.models.Slideshow(e(i, this.$container), {
              dots: !0,
              autoplay: !0,
              arrows: !1,
              adaptiveHeight: !0,
              speed: 600,
            }))
          : console.warn('[' + this.name + '] - Element matching ' + i + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        onBlockSelect: function(t) {
          this.slideshow.goToSlideByBlockId(t.detail.blockId), this.slideshow.pause()
        },
      })),
      t
    )
  })(jQuery)),
  (theme.TransparentLabeling = (function(e) {
    var i = '[data-slideshow-wrapper]',
      n = '[data-label-item]',
      s = '[data-label-button]',
      o = 'is-active'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'transparentLabeling'),
        (this.namespace = '.' + this.name),
        e(i, this.$container).length
          ? ((this.slideshow = new slate.models.Slideshow(e(i, this.$container), {
              arrows: !1,
              dots: !0,
              autoplay: !0,
            })),
            e(s, this.$container).on('click', this.toggleLabel.bind(this)))
          : console.warn('[' + this.name + '] - Element matching ' + i + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        toggleLabel: function(t) {
          ;($element = e(t.currentTarget)),
            ($elementLabel = e(t.currentTarget).parents(n)),
            $elementLabel.hasClass(o) ? $elementLabel.removeClass(o) : (e(n).removeClass(o), $elementLabel.addClass(o))
        },
        onSelect: function() {
          console.log('[' + this.name + '] - section:select')
        },
        onShow: function() {
          console.log('[' + this.name + '] - section:show')
        },
        onLoad: function() {
          console.log('[' + this.name + '] - section::load')
        },
        onUnload: function() {
          console.log('[' + this.name + '] - section::unload')
        },
      })),
      t
    )
  })(jQuery)),
  (theme.VideoPlayer = (function(e) {
    var i = '[data-video-frame]',
      n = '.icon-play',
      t = 'is-playing',
      s = 'data-video-type',
      o = 'vimeo'
    function a(t) {
      ;(this.$container = e(t)),
        (this.name = 'videoPlayer'),
        (this.namespace = '.' + this.name),
        1 === e(i, this.$container).length &&
          ((this.video = this.bindVideoPlayer(this.getVideoType())),
          this.video &&
            (e(n, this.$container).on(
              'click',
              function() {
                this.playVideo()
                  .then(
                    function() {
                      this.addPlayingClass()
                    }.bind(this)
                  )
                  .catch(
                    function() {
                      this.removePlayingClass()
                    }.bind(this)
                  )
              }.bind(this)
            ),
            this.video.on('pause', this.removePlayingClass.bind(this))))
    }
    return (
      (a.prototype = e.extend({}, a.prototype, {
        bindVideoPlayer: function(t) {
          if (t === o) return new Vimeo.Player(e(i))
        },
        getVideoURL: function() {
          videoType === o && (this.video = new Vimeo.Player(e(i)))
        },
        playVideo: function() {
          return this.video.play()
        },
        addPlayingClass: function() {
          this.$container.addClass(t)
        },
        removePlayingClass: function() {
          this.$container.removeClass(t)
        },
        getVideoType: function() {
          return this.$container.attr(s)
        },
      })),
      a
    )
  })(jQuery)),
  (theme.FAQs = (function(i) {
    var e = '[data-faqs-container]',
      n = '[data-faq-expand]',
      s = '[data-faq-content]',
      o = '[data-faq-tab]',
      a = '.faqs-category__items',
      r = '.faqs__tabs-item',
      l = '.faqs-category__question',
      c = '.panel__title-icon',
      h = '[data-mobile-faq-select]'
    function t(t) {
      ;((_this = this).$container = i(t)),
        i(e).on('click', n, this.toggleQuestion.bind(this)),
        i(e).on('click', o, this.toggleCategory.bind(this)),
        i(e).on('change', h, this.toggleMobileCategory.bind(this))
    }
    return (
      (t.prototype = i.extend({}, t.prototype, {
        toggleQuestion: function(t) {
          var e = i(t.currentTarget),
            t = i(t.currentTarget)
              .parent('.faqs-category__item')
              .siblings('.faqs-category__item')
          i(e).hasClass('is-opened')
            ? (i(e)
                .find(c)
                .removeClass('opened'),
              i(e)
                .find(l)
                .removeClass('u-fw-bold'),
              i(e)
                .siblings(s)
                .slideUp(),
              i(e).removeClass('is-opened'))
            : (i(t)
                .find(s)
                .slideUp(),
              i(t)
                .find(c)
                .removeClass('opened'),
              i(t)
                .find(l)
                .removeClass('u-fw-bold'),
              i(e)
                .find(c)
                .addClass('opened'),
              i(e)
                .find(l)
                .addClass('u-fw-bold'),
              i(e)
                .siblings(s)
                .slideDown(),
              i(e).addClass('is-opened'))
        },
        toggleMobileCategory: function(t) {
          t.preventDefault()
          var e = i(t.currentTarget).val()
          this._activateTab(t.currentTarget, e)
        },
        toggleCategory: function(t) {
          t.preventDefault()
          var e = i(t.currentTarget).data('category-target')
          this._activateTab(t.currentTarget, e)
        },
        _activateTab: function(t, e) {
          i(r).removeClass('active'),
            i(t)
              .parent()
              .addClass('active'),
            i(a).hide(),
            i(a + '[data-category="' + e + '"]').fadeIn()
        },
      })),
      t
    )
  })(jQuery)),
  (theme.NutritionFacts = (function() {
    var e = '[data-category-link][data-category-content]',
      i = 'is-active',
      n = 'hidden'
    function t(t) {
      ;(this.$container = $(t)),
        (this.name = 'nutrition-facts'),
        (this.namespace = '.' + this.name),
        (this.$categoryLinks = $(e, this.$container)),
        this.$container.on('click', e, this.onCategoryLinkClick.bind(this))
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        onCategoryLinkClick: function(t) {
          t.preventDefault()
          var e = $(t.currentTarget),
            t = e.data('category-content')
          this.$categoryLinks.removeClass(i),
            e.addClass(i),
            $('[data-category-content]:visible').addClass(n),
            $('[data-category-content=' + t + ']').removeClass(n)
        },
      })),
      t
    )
  })(slate)),
  (theme.ProductCompare = (function(e) {
    var i = '[data-slideshow-wrapper]'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'productCompare'),
        (this.namespace = '.' + this.name),
        e(i, this.$container).length
          ? e(window).width() < slate.breakpoints.getBreakpointMinWidth('md') &&
            (this.slideshow = new slate.models.Slideshow(e(i, this.$container), {
              dots: !0,
              autoplay: !1,
              fade: !1,
              arrows: !1,
              adaptiveHeight: !0,
              speed: 500,
            }))
          : console.warn('[' + this.name + '] - Element matching ' + i + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        onBlockSelect: function(t) {
          this.slideshow.goToSlideByBlockId(t.detail.blockId), this.slideshow.pause()
        },
      })),
      t
    )
  })(jQuery)),
  (theme.PromoPlayer = (function(e) {
    var i = '[data-video-frame--mobile]',
      n = '[data-video-frame--popup]',
      s = '[data-mobile-play]',
      o = '[data-modal-play]',
      a = '[data-modal-wrapper]',
      r = '[data-modal-close]',
      t = 'is-playing'
    function l(t) {
      ;(this.$container = e(t)),
        (this.name = 'promoPlayer'),
        (this.namespace = '.' + this.name),
        1 === e(i, this.$container).length &&
          ((t = e(document)),
          (this.videoPopUp = new Vimeo.Player(e(n))),
          (this.video = new Vimeo.Player(e(i))),
          e(s, this.$container).on('click', this.mobilePlayVideo.bind(this)),
          e(o, this.$container).on('click', this.modalPlayVideo.bind(this)),
          e(a, this.$container)
            .not('.modalDialog')
            .on('click', this.modalPauseVideo.bind(this)),
          e(r, this.$container).on('click', this.pauseModalVideo.bind(this)),
          this.video.on('pause', this.mobilePauseVideo.bind(this)),
          t.on('keyup', this.modalKeyboardClose.bind(this)))
    }
    return (
      (l.prototype = e.extend({}, l.prototype, {
        mobilePlayVideo: function() {
          this.$container.addClass(t), this.video.play()
        },
        modalPlayVideo: function() {
          this.videoPopUp.play()
        },
        modalPauseVideo: function(t) {
          t.currentTarget != e('.modal-dialog', this.$container) && this.pauseModalVideo()
        },
        pauseModalVideo: function() {
          this.videoPopUp.pause()
        },
        mobilePauseVideo: function() {
          this.$container.removeClass(t)
        },
        modalKeyboardClose: function(t) {
          27 == t.keyCode && this.videoPopUp.getPaused() && (e(a).removeClass('in'), this.pauseModalVideo())
        },
      })),
      l
    )
  })(jQuery)),
  (theme.FloatingContentGrid = (function(e) {
    var i = '[data-slideshow]',
      n = '[data-slideshow-wrapper]',
      s = '[data-floating-content-arrow-prev]',
      o = '[data-floating-content-arrow-next]'
    function t(t) {
      ;((_this = this).$container = e(t)),
        e(n, this.$container).length
          ? ((t = {
              dots: (t = e(i, this.$container).data()).dots || !1,
              autoplay: t.autoplay || !1,
              infinite: !0,
              speed: t.speed || 300,
              fade: !1,
              slidesToShow: 4,
              slidesToScroll: 1,
              adaptiveHeight: !0,
              swipe: !1,
              prevArrow: e(s, this.$container),
              nextArrow: e(o, this.$container),
              responsive: [
                { breakpoint: 1900, settings: { slidesToShow: 3, adaptiveHeight: !1 } },
                {
                  breakpoint: slate.breakpoints.getBreakpointMinWidth('lg'),
                  settings: { slidesToShow: 2, adaptiveHeight: !1 },
                },
                {
                  breakpoint: slate.breakpoints.getBreakpointMinWidth('sm'),
                  settings: { slidesToShow: 1, swipe: !0, adaptiveHeight: !0 },
                },
              ],
            }),
            (this.slideshow = new slate.models.Slideshow(e(n, this.$container), t)))
          : console.warn('[' + this.name + '] - Element matching ' + n + ' required to initialize')
    }
    return (t.prototype = e.extend({}, t.prototype, {})), t
  })(jQuery)),
  (theme.MealsCounter = (function(l) {
    var c = '[data-counter-container]',
      h = '[data-counter-tile]'
    function t(t) {
      ;(this.$container = l(t)),
        (this.$counter = l(c, this.$container)),
        (this.$window = l(window)),
        (this.name = 'mealsCounter'),
        (this.namespace = '.' + this.name),
        (this.settings = {
          originalCount: this.$counter.data('original-count'),
          animationSpeed: this.$counter.data('counter-speed'),
        }),
        this.$window.on('scroll', l.throttle(20, this.calculateCounterPosition.bind(this)))
    }
    return (
      (t.prototype = l.extend({}, t.prototype, {
        animateCounter: function(t, e) {
          var i = l(h).eq(t),
            n = i.data('value'),
            s = 0,
            o = e.settings.animationSpeed,
            a = '',
            r = t + 1
          l(c).addClass('counting')
          a = setInterval(function() {
            s == n
              ? (clearInterval(a), r <= l(h).length - 1 && (e.animateCounter(r, e), l(c).addClass('animated')))
              : ((s += 1), i.text(s))
          }, o)
        },
        calculateCounterPosition: function() {
          var t = l(c).offset().top,
            e = l(c).offset().top + l(c).outerHeight(),
            i = this.$window.scrollTop(),
            n = i + this.$window.innerHeight()
          i < t && e < n && !l(c).hasClass('animated') && !l(c).hasClass('counting') && this.animateCounter(0, this)
        },
        onSelect: function() {
          console.log('[' + this.name + '] - section:select')
        },
        onShow: function() {
          console.log('[' + this.name + '] - section:show')
        },
        onLoad: function() {
          console.log('[' + this.name + '] - section::load')
        },
        onUnload: function() {
          console.log('[' + this.name + '] - section::unload')
        },
      })),
      t
    )
  })(jQuery)),
  (theme.CMSPage = (function(e) {
    var i = '[data-block-type="timeline"]',
      n = '[data-block-type="press-quotes"]'
    function t(t) {
      ;(this.$container = e(t)),
        (this.name = 'cmsPage'),
        (this.namespace = '.' + this.name),
        e(n, this.$container).each(function(t, e) {
          new slate.models.PressQuoteSlideshow(e)
        }),
        e(i, this.$container).each(function(t, e) {
          new slate.models.Timeline(e)
        })
    }
    return (t.prototype = e.extend({}, t.prototype, {})), t
  })(jQuery)),
  (theme.TestimonialCarousel = (function(e) {
    var i = '[data-slideshow-wrapper]',
      n = '[data-slideshow]',
      s = '[data-slideshow-slide]'
    function t(t) {
      ;(this.$container = e(t)),
        (this.$slideshow = e(n, this.$container)),
        (this.$slides = e(s, this.$container)),
        (this.name = 'testimonialsCarousel'),
        (this.namespace = '.' + this.name),
        (this.settings = { slidesToShow: 1, dots: !0, infinite: !1, fade: !1, arrows: !1 }),
        1 < e(s, this.$container).length &&
          (this.slideshow = new slate.models.Slideshow(e(i, this.$container), this.settings))
    }
    return (t.prototype = e.extend({}, t.prototype, {})), t
  })(jQuery)),
  (theme.AboutUsCarousel = (function(e) {
    var i = '[data-slideshow]',
      n = '[data-slideshow-slide]',
      s = '[data-slideshow-wrapper]',
      o = '[data-about-us-carousel-arrow-prev]',
      a = '[data-about-us-carousel-arrow-next]',
      r = 'is-active'
    function t(t) {
      ;((_this = this).$container = e(t)),
        (this.$slideshowSlides = e(n, this.$container)),
        (this.$slideshowWrapper = e(s, this.$container))
      t = e(i, this.$container).data()
      this.$slideshowWrapper.length
        ? ((t = {
            dots: t.dots || !1,
            autoplay: t.autoplay || !1,
            speed: t.speed || 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: !1,
            mobileFirst: !0,
            swipe: !1,
            arrows: !0,
            infinite: !0,
            cssEase: 'ease',
            accessibility: !1,
            prevArrow: e(o, this.$container),
            nextArrow: e(a, this.$container),
            responsive: [
              { breakpoint: slate.breakpoints.getBreakpointMinWidth('xl'), settings: { slidesToShow: 2.5, swipe: !0 } },
              { breakpoint: slate.breakpoints.getBreakpointMinWidth('sm'), settings: { slidesToShow: 1.5, swipe: !0 } },
              { breakpoint: slate.breakpoints.getBreakpointMinWidth('xs'), settings: { slidesToShow: 1, swipe: !0 } },
            ],
          }),
          this.$slideshowWrapper.on('init', this.init.bind(this)),
          this.$slideshowWrapper.on('beforeChange', this.beforeChangeHandler.bind(this)),
          this.$slideshowWrapper.on('reInit', this.reInit.bind(this)),
          (this.slideshow = new slate.models.Slideshow(this.$slideshowWrapper, t)))
        : console.warn('[' + this.name + '] - Element matching ' + s + ' required to initialize')
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        init: function(t) {
          this.$slideshowSlides.hasClass(r) || this.$slideshowSlides.eq(0).addClass(r)
        },
        reInit: function(t) {
          this.$slideshowSlides.removeClass(r)
        },
        beforeChangeHandler: function(t, e, i, n) {
          n = this.$slideshowSlides.eq(n)
          this.$slideshowSlides.removeClass(r), n.addClass(r)
        },
      })),
      t
    )
  })(jQuery)),
  (theme.NutritionCards = (function(e, t, i) {
    var n = e(window),
      s = i.getBreakpointMinWidth('md') - 1,
      o = '[data-nutrition-card]',
      a = '[data-card-link]',
      r = '[data-cards-wrapper]',
      l = '[data-panels-wrapper]',
      c = '[data-pagination-next]',
      h = '[data-pagination-prev]',
      d = 'carousel',
      u = 'tabs',
      p = 'data-toggle',
      m = 'data-slick-index',
      g = 'state-tabs',
      f = 'state-carousel',
      v = { slidesToShow: 1, slidesToScroll: 1, arrows: !0, fade: !0, draggable: !0, swipeToSlide: !0 },
      $ = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !1,
        fade: !1,
        draggable: !0,
        swipeToSlide: !0,
        variableWidth: !0,
        centerMode: !1,
      }
    function w(t) {
      ;(this.$container = e(t)),
        (this.$cardLinks = e(a, this.$container)),
        (this.$panelsWrapper = e(l, this.$container)),
        (this.$cardsWrapper = e(r, this.$container)),
        this.$cardLinks.length &&
          this.$panelsWrapper.length &&
          ((this.$arrowNext = e(c, this.$container)),
          (this.$arrowPrev = e(h, this.$container)),
          (this.slickInit = !1),
          this.init(),
          n.on('resize', this.init.bind(this)),
          this.$container.on('click', a, this.handleCardsLinkClick.bind(this)))
    }
    return (
      (w.prototype = e.extend({}, w.prototype, {
        init: function() {
          var t = this.getState()
          switch ((this.toggleContainerClass(t), t)) {
            case u:
              this.destroyCarousel(), this.activateTabs()
              break
            case d:
              this.destroyTabs(), this.activateCarousel()
          }
        },
        handleCardsLinkClick: function(t) {
          t.preventDefault(),
            this.getState() == d &&
              ((t = e(t.target)
                .closest(o)
                .attr(m)),
              this.$panelsWrapper.length && this.$panelsWrapper.slick('slickGoTo', t))
        },
        activateTabs: function() {
          this.$cardLinks.attr(p, 'tab')
        },
        activateCarousel: function() {
          !this.slickInit &&
            this.$panelsWrapper.length &&
            (this.$panelsWrapper.slick(this.getCarouseSettings()),
            this.$cardsWrapper.slick(this.getNavSettings()),
            (this.slickInit = !0))
        },
        destroyCarousel: function() {
          this.slickInit &&
            (this.$panelsWrapper.slick('unslick'), this.$cardsWrapper.slick('unslick'), (this.slickInit = !1))
        },
        destroyTabs: function() {
          this.$cardLinks.removeAttr(p)
        },
        toggleContainerClass: function(t) {
          switch (t) {
            case u:
              this.$container.removeClass(f), this.$container.addClass(g)
              break
            case d:
              this.$container.removeClass(g), this.$container.addClass(f)
          }
        },
        getState: function() {
          return t.getViewportWidth() < s ? d : u
        },
        getCarouseSettings: function() {
          var t = {}
          return (
            this.$cardsWrapper.length && (t.asNavFor = this.$cardsWrapper),
            this.$arrowPrev.length &&
              this.$arrowNext.length &&
              ((t.prevArrow = this.$arrowPrev), (t.nextArrow = this.$arrowNext)),
            e.extend({}, v, t)
          )
        },
        getNavSettings: function() {
          var t = {}
          return this.$panelsWrapper.length && (t.asNavFor = this.$panelsWrapper), e.extend({}, $, t)
        },
      })),
      w
    )
  })(jQuery, slate.utils, slate.breakpoints)),
  (theme.ProductTransparentLabeling = (function(n, s) {
    var e = '[data-tl-carousel]',
      i = '[data-tl-navigation]',
      o = '[data-tl-navigation-item]',
      a = '[data-tl-pagination-next]',
      r = '[data-tl-pagination-prev]',
      l = '[data-tl-bottle-image]',
      c = 'slide-active',
      h = 'slick-initialized',
      d = 'data-slick-index',
      u = 'data-tl-navigation-item',
      p = {
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        arrows: !0,
        fade: !0,
        draggable: !0,
        swipeToSlide: !0,
        infinite: !0,
      },
      m = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !1,
        fade: !1,
        draggable: !0,
        swipeToSlide: !0,
        variableWidth: !0,
        centerMode: !1,
        infinite: !0,
      }
    function t(t) {
      ;(this.$container = n(t)),
        (this.$carousel = n(e, this.$container)),
        (this.$navigation = n(i, this.$container)),
        (this.$prev = n(r, this.$container)),
        (this.$next = n(a, this.$container)),
        (this.$navigationItems = n(o, this.$container)),
        this.$carousel.length &&
          ((t = this.getCarouselConfig(!0, !1)),
          this.initSlick(this.$carousel, t),
          (this.navCarouselInit = !1),
          this.$navigation.length &&
            this.$navigationItems.length &&
            (this.$navigation.on(
              'init',
              function() {
                var t = n(o, this.$container)
                t.length && this.bindClickEventOnNavItems(t)
              }.bind(this)
            ),
            this.bindNavCarouselIfOverflow(this.$navigation, this.$navigationItems, this.$carousel),
            n(window).resize(
              n.throttle(
                20,
                function() {
                  this.bindNavCarouselIfOverflow(this.$navigation, this.$navigationItems, this.$carousel)
                }.bind(this)
              )
            ),
            this.$carousel.on(
              'beforeChange',
              function(t, e, i, n) {
                this.setActiveSlide(n)
              }.bind(this)
            )),
          (t = this.$navigationItems).length && this.bindClickEventOnNavItems(t),
          (this.$bottleImage = n(l, this.$container)),
          this.$bottleImage.length && this.$bottleImage.on('click', this.slickNextSlide.bind(this)))
    }
    return (
      (t.prototype = n.extend({}, t.prototype, {
        initSlick: function(t, e) {
          t && t.length && (t.slick(e), this.setActiveSlide(0))
        },
        destroySlick: function(t) {
          t && t.length && t.slick('unslick')
        },
        bindNavCarouselIfOverflow: function(t, e, i) {
          var n
          t &&
            t.length &&
            e &&
            e.length &&
            ((n = this.slickInitialized(t)),
            s(t, e)
              ? n ||
                (i.one(
                  'destroy',
                  function() {
                    this.initSlick(i, this.getCarouselConfig(!0, !0))
                  }.bind(this)
                ),
                this.destroySlick(i),
                this.initSlick(t, this.getNavConfig(!0)))
              : n &&
                (i.one(
                  'destroy',
                  function() {
                    this.initSlick(i, this.getCarouselConfig(!0, !1))
                  }.bind(this)
                ),
                this.destroySlick(t),
                this.destroySlick(i)))
        },
        bindClickEventOnNavItems: function(t) {
          t && t.length && t.on('click', this.onNavigationItemClick.bind(this))
        },
        onNavigationItemClick: function(t) {
          var e = n(t.target),
            t = e.attr(d),
            e = null != t && '' !== t ? t : e.attr(u)
          this.slickInitialized(this.$carousel) && this.$carousel.slick('slickGoTo', e)
        },
        slickNextSlide: function() {
          this.$carousel.slick('slickNext')
        },
        slickInitialized: function(t) {
          return t.hasClass(h)
        },
        setActiveSlide: function(t) {
          this.$navigationItems.removeClass(c), this.$navigationItems.attr('aria-current', 'false')
          t = n('[' + u + '=' + t + ']', this.$container)
          this.slickInitialized(this.$navigation) || (t.addClass(c), t.attr('aria-current', 'true'))
        },
        getCarouselConfig: function(t, e) {
          var i = {}
          return (
            e && this.$navigation.length && (i.asNavFor = this.$navigation),
            t && this.$prev.length && this.$next.length && ((i.prevArrow = this.$prev), (i.nextArrow = this.$next)),
            n.extend({}, p, i)
          )
        },
        getNavConfig: function(t) {
          var e = {}
          return t && this.$carousel.length && (e.asNavFor = this.$carousel), n.extend({}, m, e)
        },
      })),
      t
    )
  })(jQuery, slate.utils.childrenLargerThanParent)),
  (theme.CustomerQuotes = (function(e) {
    var i = '[data-cq-carousel]',
      n = '[data-cq-pagination-next]',
      s = '[data-cq-pagination-prev]',
      o = '[data-quote]',
      a = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: !0,
        fade: !0,
        draggable: !0,
        swipeToSlide: !0,
        infinite: !0,
        adaptiveHeight: !0,
      }
    function t(t) {
      ;(this.$container = e(t)),
        (this.$carousel = e(i, this.$container)),
        (this.$prev = e(s, this.$container)),
        (this.$next = e(n, this.$container)),
        (this.$quotes = e(o, this.$container)),
        this.$carousel.length && ((t = this.getCarouselConfig()), this.initSlick(this.$carousel, t))
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        initSlick: function(t, e) {
          t && t.length && t.slick(e)
        },
        getCarouselConfig: function() {
          var t = {}
          return (
            this.$prev.length && this.$next.length && ((t.prevArrow = this.$prev), (t.nextArrow = this.$next)),
            e.extend({}, a, t)
          )
        },
      })),
      t
    )
  })(jQuery)),
  (theme.ProductPowerReviews = (function(e) {
    var i = '[data-review-display]',
      n = '[data-question-display]',
      s = '[data-reviews-header]',
      o = 'hidden'
    function t(t) {
      ;(this.$container = e(t)),
        (this.$reviews = e(i, this.$container)),
        (this.$questions = e(n, this.$container)),
        (this.$header = e(s, this.$container))
      t = e.Deferred()
      this.waitForPowerReviews(t, 0),
        t.done(
          function() {
            this.showElement(this.$container)
          }.bind(this)
        )
    }
    return (
      (t.prototype = e.extend({}, t.prototype, {
        waitForPowerReviews: function(t, e) {
          100 < e ||
            (this.hasContent(this.$reviews) || this.hasContent(this.$questions)
              ? t.resolve()
              : window.setInterval(
                  function() {
                    this.waitForPowerReviews(t, ++e)
                  }.bind(this),
                  100
                ))
        },
        hasContent: function(t) {
          return !(!t || !t.length) && '' !== t.html()
        },
        showElement: function(t) {
          t.removeClass(o)
        },
        hideElement: function(t) {
          t.addClass(o)
        },
      })),
      t
    )
  })(jQuery)),
  (theme.NutritionCompare = (function(o, i, e) {
    var n = '[data-nutrition-compare]',
      s = '[data-compare-container]',
      r = 'animated',
      a = 3e3,
      l = 'data-timeout-duration'
    function t(t) {
      ;(this.$container = o(t)),
        (this.$compareCards = o(n, this.$container)),
        (this.$compareContainer = o(s, this.$container)),
        this.$container.length &&
          this.$compareCards.length &&
          ((this.name = 'nutritionCompare'),
          (this.namespace = '.' + this.namespace),
          (this.transitionEndEvent = i.whichTransitionEnd()),
          (this.supportsCssTransitions = e.hasOwnProperty('csstransitions') && e.csstransitions),
          (this.timeout = this.getTimeoutDuration()),
          this.setContainerHeight(),
          o(window).on('resize', this.setContainerHeight.bind(this)),
          (this.whenBreakAnimation = null),
          this.$compareCards.length &&
            this.whenScrolledToElement(this.$container).done(
              function() {
                ;(this.whenBreakAnimation = this.startAnimation()),
                  this.$compareCards.on(
                    'click',
                    function(t) {
                      ;(t = o(t.target)
                        .closest(n)
                        .index()),
                        (t = this.getNextCardIndex(t, this.$compareCards.length))
                      this.whenBreakAnimation = this.startAnimation(t)
                    }.bind(this)
                  )
              }.bind(this)
            ))
    }
    return (
      (t.prototype = o.extend({}, t.prototype, {
        startAnimation: function(t) {
          this.whenBreakAnimation && this.breakAnimation(this.whenBreakAnimation)
          var e = o.Deferred()
          return void 0 === t && this.animateNutritionCard(e), this.animateNutritionCard(e, t), e
        },
        breakAnimation: function(t) {
          t && t.resolve()
        },
        animateNutritionCard: function(t, e) {
          var i,
            n,
            s,
            o = !1,
            a = !1
          t.done(function() {
            o = !0
          }),
            o ||
              ((i = this.$compareCards.length),
              e < 0 ||
                i <= e ||
                (void 0 === e && ((a = !0), (e = 0)),
                (s = this.getPrevCardIndex(e, i)),
                (n = this.getNextCardIndex(e, i)),
                (e = this.$compareCards.eq(e)),
                (s = a ? null : this.$compareCards.eq(s)) && s.length && s.removeClass(r),
                e.addClass(r),
                this.supportsCssTransitions
                  ? e.one(
                      this.transitionEndEvent,
                      function() {
                        window.setTimeout(
                          function() {
                            this.animateNutritionCard(t, n)
                          }.bind(this),
                          this.timeout
                        )
                      }.bind(this)
                    )
                  : window.setTimeout(
                      function() {
                        this.animateNutritionCard(t, n)
                      }.bind(this),
                      this.timeout
                    )))
        },
        whenScrolledToElement: function(n) {
          var s = o.Deferred()
          return (
            i.elementIsWithinViewport(n) && s.resolve(),
            o(window).scroll(
              o.throttle(20, function() {
                var t = n.offset().top,
                  e = n.outerHeight(!0),
                  i = (o(window).height(), o(window).scrollTop())
                t - e <= i && i < t + e && s.resolve()
              })
            ),
            s
          )
        },
        getPrevCardIndex: function(t, e) {
          return i.naturalMod(t - 1, e)
        },
        getNextCardIndex: function(t, e) {
          return (t + 1) % e
        },
        getTimeoutDuration: function() {
          var t = this.$container.attr(l)
          return t || a
        },
        setContainerHeight: function() {
          var t = this.$compareCards.eq(0).outerHeight(!0)
          this.$compareContainer.css('height', t)
        },
      })),
      t
    )
  })(jQuery, slate.utils, Modernizr)),
  (theme.ProductNutritionSlideshow = (function(s) {
    var o = '[data-nutrition-slideshow]',
      a = '[data-nutrition-slideshow-nav]',
      r = '[data-slideshow-nav-slide]'
    function t(t) {
      this.$container = s(t)
      var e,
        i = s(o, this.$container),
        n = s(a, this.$container)
      i.length &&
        ((t = {
          speed: 600,
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: !(e = {
            speed: 800,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !1,
            dots: !1,
            fade: !1,
            draggable: !0,
            swipeToSlide: !0,
            infinite: !1,
            asNavFor: n,
          }),
          fade: !1,
          draggable: !1,
          swipeToSlide: !1,
          variableWidth: !1,
          infinite: !1,
          asNavFor: i,
          focusOnSelect: !1,
          centerMode: !1,
          vertical: !0,
          responsive: [
            {
              breakpoint: slate.breakpoints.getBreakpointMinWidth('md'),
              settings: { vertical: !1, slidesToShow: 1.2 },
            },
          ],
        }),
        i.slick(e),
        n.slick(t),
        n.on('click', r, function() {
          i.slick('slickGoTo', s(this).data('slick-index'))
        }))
    }
    return (t.prototype = s.extend({}, t.prototype, { onBlockSelect: function(t) {} })), t
  })(jQuery)),
  (theme.prInstagram = (function() {
    var e = { root: null, rootMargin: '480px', threshold: 0 },
      i = '[data-widget-config-json]'
    function t(t) {
      ;(this.$container = t),
        (this.widgetConfig = JSON.parse($(i, this.$container).html())),
        (this.observer = new IntersectionObserver(this.callback.bind(this), e)),
        this.observer.observe(this.$container)
    }
    return (
      (t.prototype = $.extend({}, t.prototype, {
        callback: function(t) {
          var e = this
          t.forEach(function(t) {
            t.isIntersecting && (window.pwr('render', e.widgetConfig), e.observer.unobserve(e.$container))
          })
        },
      })),
      t
    )
  })()),
  (theme.customers = (function() {
    var i = $('[data-customer-location-select]')
    i.length &&
      i.on('change', function() {
        var t = i.val(),
          e = document.createElement('a')
        ;(e.href = t),
          (e.host === window.location.host && e.pathname === window.location.pathname) || (window.location = t)
      })
  })()),
  (theme.customerAddresses = (function() {
    var e = $('#AddressNewForm'),
      i = {
        addressNewToggle: '[data-address-new-toggle]',
        addressEditShow: '[data-address-edit-show][data-form-id]',
        addressEditCancel: '[data-address-edit-cancel][data-form-id]',
        addressDelete: '[data-address-delete][data-form-id]',
      },
      n = 'hide'
    Shopify &&
      (e.length &&
        new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
          hideElement: 'AddressProvinceContainerNew',
        }),
      $('.address-country-option').each(function() {
        var t = $(this).data('form-id'),
          e = 'AddressCountry_' + t,
          i = 'AddressProvince_' + t,
          t = 'AddressProvinceContainer_' + t
        new Shopify.CountryProvinceSelector(e, i, { hideElement: t })
      })),
      $(i.addressNewToggle).on('click', function(t) {
        t.preventDefault(), e.toggleClass(n)
      }),
      $(i.addressEditShow).on('click', function(t) {
        t.preventDefault()
        t = $(this).data('form-id')
        $(i.addressForm).addClass(n), $('#EditAddress_' + t).toggleClass(n)
      }),
      $(i.addressEditCancel).on('click', function(t) {
        t.preventDefault()
        t = $(this).data('form-id')
        $('#EditAddress_' + t).addClass(n)
      }),
      $(i.addressDelete).on('click', function(t) {
        t.preventDefault()
        var e = $(this),
          t = e.data('form-id'),
          e = e.data('confirm-message')
        confirm(e || 'Are you sure you wish to delete this address?') &&
          Shopify.postLink('/account/addresses/' + t, { parameters: { _method: 'delete' } })
      })
  })()),
  (theme.customerLogin = (function() {
    var e = '#customer_login',
      t = '#RecoverPassword',
      i = '#HideRecoverPasswordLink'
    function n(t) {
      t.preventDefault(), s()
    }
    function s() {
      $('#RecoverPasswordForm').toggleClass('hide'),
        $('#CustomerLoginForm').toggleClass('hide'),
        $('#RecoverPassword').toggleClass('hide'),
        $('#RecoverPasswordForm').hasClass('hide') ||
          $('#RecoverPasswordForm')
            .find("input[type='email']:first")
            .focus()
    }
    $(t).length &&
      ($(e).validate({
        rules: { 'customer[email]': { required: !0, email: !0 }, 'customer[password]': { required: !0 } },
        messages: {
          'customer[password]': 'Please provide a password',
          'customer[email]': 'Please enter a valid email address',
        },
        submitHandler: function(t) {
          $(e)[0].submit()
        },
      }),
      '#recover' === window.location.hash && s(),
      $('.reset-password-success').length && $('#ResetSuccess').removeClass('hide'),
      $(t).on('click', n),
      $(i).on('click', n))
  })()),
  (theme.customerRegister = (function() {
    var a = '#create_customer',
      r = 'input[name="customer[accepts_marketing]"]'
    $(a).length &&
      $(a).validate({
        rules: {
          'customer[first_name]': { required: !0 },
          'customer[last_name]': { required: !0 },
          'customer[email]': { required: !0, email: !0 },
          'customer[password]': { required: !0, minlength: 6 },
        },
        messages: {
          'customer[first_name]': 'Please provide your first name.',
          'customer[last_name]': 'Please provide your last name.',
          'customer[password]': 'Please provide a password 6 characters or longer.',
          'customer[email]': 'Please enter a valid email address.',
        },
        submitHandler: function(t) {
          var e = $('input[name="customer[email]"]', a).val(),
            i = $('input[name="customer[first_name]"]', a).val(),
            n = $('input[name="customer[last_name]"]', a).val(),
            s = $('input[name="klaviyo_list_id"]', a).val(),
            o = { 'channels.email.address': e, 'first-name': i, 'last-name': n, Account_Creation: !0 }
          $(r).is(':checked') &&
            ((o['channels.email.subscribeStatus'] = 'subscribed'),
            (n = {
              async: !0,
              crossDomain: !0,
              url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
              method: 'POST',
              headers: { 'content-type': 'application/x-www-form-urlencoded', 'cache-control': 'no-cache' },
              data: {
                g: s,
                email: e,
                $fields: '$source, $first_name, $last_name',
                $source: 'Account Creation',
                $first_name: i,
                $last_name: n,
              },
            }),
            $.ajax(n).done(function(t) {
              console.log(t)
            })),
            $(a)[0].submit()
        },
      })
  })()),
  (theme.styleguide = (function() {
    var t = $(document.body)
    t.is('.template-page-styles') &&
      (t.on('click', '.dot', function() {
        $(this).toggleClass('is-active')
      }),
      t.on('click', 'a[href="#"]', function() {
        return !1
      }))
  })()),
  (theme.components = (function() {
    var t = $(document.body)
    t.is('.template-page-components') &&
      ($('[data-slideup-alert-form]').on('submit', function(t) {
        t.preventDefault(),
          new slate.models.SlideupAlert({
            title: $(this)
              .find('input[name="title"]')
              .val(),
            text: $(this)
              .find('input[name="text"]')
              .val(),
          })
      }),
      t.on('click', 'a[href="#"]', function() {
        return !1
      }))
  })()),
  (theme.article = (function() {
    var t,
      e,
      i,
      n = $('.article-main')
    n.length &&
      ((t = '[data-sharing-bar]'),
      (i = '[data-related-articles]'),
      (e = $('[data-header]').outerHeight() + 20),
      (i = $(i).offset().top),
      (i = $(document).height() - i + 80),
      $(t, n).sticky({ topSpacing: e, bottomSpacing: i }))
  })()),
  (theme.ProductSection = (function() {
    var e,
      n,
      i,
      s,
      o,
      a,
      r,
      l,
      t = $(window)
    $(document.body).is('.template-product') &&
      ((e = '.section-tab-container'),
      (n = 'data-pill-index'),
      (i = '[data-tab-dropdown]'),
      (s = 'data-content-index'),
      (o = 'data-tab-content-type'),
      (a = function(t) {
        t.preventDefault()
        t = $(t.target)
        l(t.data().pillIndex)
      }),
      (r = function(t) {
        t = $(t.target)
        l(t.val())
      }),
      (l = function(t, e) {
        var i = $('[' + s + '=' + t + ']', this.$container)
        $('.nav-item', this.$container).removeClass('is-active'),
          $('[' + n + '=' + t + ']')
            .parent('.nav-item')
            .addClass('is-active'),
          $('[' + s + ']', this.$container).fadeOut(),
          i.fadeIn('slow', e)
      }),
      $(e).each(function() {
        var t = $(this)
        $('[' + n + ']', t).on('click', a), $(i, t).on('change', r)
      }),
      t.on('pdp_show_tab_section_of_type', function(t) {
        0 < $(e).length &&
          (t.preventDefault(),
          (t = $('[' + o + '=' + t.sectionType + ']', this.$contianer)),
          l(t.data().contentIndex, function() {
            $(e)[0].scrollIntoView({ behavior: 'smooth' })
          }))
      }))
  })()),
  (function(i) {
    i(window)
    var n = i(document)
    i(document.body),
      i(function() {
        var t = new slate.Sections()
        t.register('product', theme.Product),
          t.register('collection', theme.Collection),
          t.register('pencil-banner', theme.PencilBanner),
          t.register('instagram-feed', theme.InstagramFeed),
          t.register('slideshow', theme.Slideshow),
          t.register('header', theme.Header),
          t.register('footer', theme.Footer),
          t.register('ajax-cart', theme.AjaxCart),
          t.register('cart', theme.Cart),
          t.register('mobile-menu', theme.MobileMenu),
          t.register('blog', theme.Blog),
          t.register('clp', theme.Clp),
          t.register('hero', theme.Hero),
          t.register('dynamic-text', theme.DynamicText),
          t.register('iconographic-module', theme.IconographicModule),
          t.register('article-grid', theme.ArticleGrid),
          t.register('transparent-labeling', theme.TransparentLabeling),
          t.register('video-player', theme.VideoPlayer),
          t.register('faqs', theme.FAQs),
          t.register('nutrition-facts', theme.NutritionFacts),
          t.register('product-compare', theme.ProductCompare),
          t.register('promo', theme.PromoPlayer),
          t.register('meals-counter', theme.MealsCounter),
          t.register('cms-page', theme.CMSPage),
          t.register('testimonials', theme.TestimonialCarousel),
          t.register('floating-product-grid', theme.FloatingProductGrid),
          t.register('about-us-carousel', theme.AboutUsCarousel),
          t.register('nutrition-cards', theme.NutritionCards),
          t.register('product-tl', theme.ProductTransparentLabeling),
          t.register('customer-quotes', theme.CustomerQuotes),
          t.register('product-power-reviews', theme.ProductPowerReviews),
          t.register('nutrition-compare', theme.NutritionCompare),
          t.register('product-nutrition-slideshow', theme.ProductNutritionSlideshow),
          t.register('floating-content-grid', theme.FloatingContentGrid),
          t.register('pr-instagram', theme.prInstagram),
          i('.in-page-link').on('click', function(t) {
            slate.a11y.pageLinkFocus(i(t.currentTarget.hash))
          }),
          slate.a11y.pageLinkFocus(i(window.location.hash)),
          slate.rte.wrapTables({ $tables: i('.rte table'), tableWrapperClass: 'table-responsive' })
        slate.rte.wrapIframe({
          $iframes: i('.rte iframe[src*="youtube.com/embed"],.rte iframe[src*="player.vimeo"]'),
          iframeWrapperClass: 'rte__video-wrapper',
        }),
          slate.utils.userAgentBodyClass(),
          slate.utils.cookiesEnabled() &&
            (document.documentElement.className = document.documentElement.className.replace(
              'supports-no-cookies',
              'supports-cookies'
            )),
          slate.utils.chosenSelects(),
          i('.form-group.has-error').on('change keydown', '.form-control', function() {
            i(this)
              .parents('.has-error')
              .removeClass('has-error')
          })
        var e = 'is-open'
        n.on('show.bs.collapse', '.collapse', function(t) {
          i(t.currentTarget)
            .parents('.panel')
            .addClass(e)
        }),
          n.on('hide.bs.collapse', '.collapse', function(t) {
            i(t.currentTarget)
              .parents('.panel')
              .removeClass(e)
          }),
          i('.collapse.in').each(function() {
            i(this)
              .parents('.panel')
              .addClass(e)
          }),
          n.on('chosen:ready', function() {
            i('.chosen-search-input').each(function() {
              var t =
                i(this)
                  .siblings()
                  .first()
                  .text() || ''
              i(this).attr('aria-label', 'dropdown selected value: ' + t)
            })
          })
        t = i('#search-overlay')
        t.length &&
          t.on('shown.overlay', function() {
            setTimeout(function() {
              $searchOverlayfind('input[type="search"]').focus()
            }, 10)
          }),
          n.on('lazybeforeunveil', function(t) {
            var e = t.target.getAttribute('data-bg')
            e && (t.target.style.backgroundImage = 'url(' + e + ')')
          }),
          document.addEventListener('rebuy:cart.change', function(t) {
            window.Rebuy.init()
          })
      })
  })(jQuery)
